import React, { useCallback, useState, useEffect, useRef, useMemo } from 'react';
import axios, { AxiosResponse } from 'axios';
import Fuse from 'fuse.js';
import { useSnackbar } from 'notistack';
import { DataGrid, GridColDef, GridEventListener, GridRenderCellParams } from '@mui/x-data-grid';
import {
    Tooltip,
    Button,
    Alert,
    Slide,
    Modal,
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Divider,
    TextField,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    Menu,
    MenuItem,
    FormControl,
    InputLabel,
    CircularProgress,
    Rating,
    Checkbox,
    Chip,
    FormControlLabel,
    OutlinedInput,
} from '@mui/material';
import ViewModuleRoundedIcon from '@mui/icons-material/ViewModuleRounded';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import NightsStayRoundedIcon from '@mui/icons-material/NightsStayRounded';
import WbTwilightRoundedIcon from '@mui/icons-material/WbTwilightRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ModeRoundedIcon from '@mui/icons-material/ModeRounded';
import {
    Plus,
    Search,
    UserRoundPlus,
    X,
    MapPin,
    Calendar,
    Clock,
    DollarSign,
    Mail,
    Phone,
    Briefcase,
    ChevronDown,
    UserRoundCog,
    Users,
    Info,
    FileText,
    ClipboardCheck,
    ChevronLeft,
} from 'lucide-react';
import { useHistory } from 'react-router-dom';
import { WORKY_WEB_APP_PATHS } from '../../WorkyWebAppPaths';
import { StyleLinks, TopNav, PushToNewSr, PushtoSrHistory } from '../../orgViews/OrgCommonComponents';
import { convertToTitleCase } from '../../orgViews/OrgUtils';
import { EmptyInfoState } from './EmptyInfoState';
import { AddJobberWorkerTypeModal, ContractorDetailsSection, EditWorkerNameModal } from './MyAgencyWorkforceComponents';
import { ManageWorkerFileTypesModal } from '../trustvault/components/ManageWorkerFileTypesModal';
import {  WorkyContactButton, WorkyFooter } from '../../agency-logic/agency-components/AgencyComponentSetOne';
import { WorkforceHeaderActionButtons } from '../agency-components/WorkforceHeaderActionButtons';
import { useIsMobile } from '../../custom-hooks/useIsMobile';
import { JobberProfileComponent } from '../../orgViews/JobberProfileComponentOpen';
import { GetJobberResume, GetJobberProfile } from '../../shared-engineering-services/SharedAPICalls';
import { extractRatingFromRatingCategory, getFriendlyFieldDisplayValue, getFriendlyPhoneDisplayValue, getJobberStatusDisplayClassName, getJobberStatusMessage, getJobberStatusMessageForReadOnly, getJobberStatusMessageForReadOnlySingleWorker, getOrgDisplayLabel, isTestPhoneNumber, isValidString } from '../../common/CommonUtilsMethods';
import { WorkyNumberInput } from '../../common/WorkyNumberInput';
import {
    GetAllJobberAvailbilities,
    FullyHireJobberAPICall,
    ChangeJobberStatusAPICall,
    UpdateJobberWorkerTypePayRateAPICall,
    RegisterBulkJobbersPOSTAPICall,
    GetAgencyWTokenOnly,
    UpdateJobberNoteOnEmploymentConfigAPICall,
    MapJobbersToOrgLocationAPICall,
    UpdateDefaultWorkerTypePayRate,
    UpdateJobberWorkerTypeLaborSalesTax,
    UpdateOrgBillingWorkerTypeName,
    CreateShiftAssignmentConfigRuleAPICall,
    CreateShiftAssignmentConfigRuleDetail,
    ResendJobberRegistrationEmailAPICall
} from '../agency-api-calls/AgencyAPI';
import {
  GetJobberOnboardingTemplatesAPICall,
  UpdateJobberOnboardingTemplateTypeAPICall,
} from '../trustvault/jobberonboarding/JobberOnboardingTemplateAPI';
import {
  getJobberOnboardingTemplateTypeLabel,
  isJobberOnboardingTemplateActivated,
  isPrimaryJobberOnboardingTemplate,
  JobberOnboardingTemplateType,
  JOBBER_ONBOARDING_DEFAULT_TEMPLATE_TOOLTIP,
} from '../trustvault/jobberonboarding/JobberOnboardingTemplateAPIInterfaces';
import {
  CREATE_WORKER_ONBOARDING_TEMPLATE_PATH,
  buildEditJobberOnboardingTemplatePath,
} from '../trustvault/jobberonboarding/JobberOnboardingTemplatePaths';
import { WORKER_ONBOARDING_CHECKLIST_TEMPLATES_PATH, buildEditWorkerOnboardingChecklistTemplatePath } from '../trustvault/workeronboardingchecklist/WorkerOnboardingChecklistPaths';
import { ListWorkerOnboardingChecklistTemplatesAPICall } from '../trustvault/workeronboardingchecklist/WorkerOnboardingChecklistAPI';
import {
  WorkerOnboardingChecklistTemplateResponseDTO,
  getChecklistTemplateStatusLabel,
  getChecklistTemplateTypeLabel,
} from '../trustvault/workeronboardingchecklist/WorkerOnboardingChecklistInterfaces';
import { ListTrustVaultDocumentSubTypesAgencyUserAPICall } from '../trustvault/api/TrustVaultPhiDocumentsAgencyUserAPI';
import { TrustVaultDocumentSubTypeRespDTO } from '../trustvault/interfaces/TrustVaultPhiDocumentsAgencyUserInterfaces';
import {
    WorkTaskQuestionResponseDTO,
    WorkTaskTemplateResponseDTO,
    formatWorkTaskTemplateCreatedDisplay,
    isFileUploadWorkTaskQuestionType,
    templateRequiresWorkerSignature,
} from '../trustvault/worktasks/WorkTaskTemplateInterfaces';
import { UpdateJobberWorkerTypeStatusAPICall } from '../agency-api-calls/AgencyJobberWorkerTypeAPIs';
import { isJobberWorkerTypeActive } from '../agency-data/JobberWorkerTypeUtils';
import { RemoveJobberWorkerTypeFromJobberAPICall, RemoveJobberEmploymentDeductionsConfigAPICall, AddJobberEmploymentDeductionsConfigAPICall } from '../agency-api-calls/AgencyJobberActionsAPIs';
import {
    JobberFullProfileDetails,
    JobberAvalTimeWindows,
    RegisterJobberRequestSimpleDTO,
    RegisterJobberRequestSimpleJobberworkerTypeDTO,
    JobberWorkerEmploymentType,
    CreateJobberWorkerTypeReqDTO,
    AgencyObjClient,
    MapJobbersToOrgLocationRequestDTO,
    OrgJobberLocationConfigDTO,
    JobberOrgLocationStatus,
    CreateOrgForAgencyFormData,
    UpdateDefaultWorkerTypePayRateRequestDTO,
    CreateJobberWorkerTypeDTO,
    ChangeJobberStatusReqDTO,
    ResendJobberRegistrationEmailRequestDTO,
    JobberEmploymentDeductionsConfigDTO,
} from '../agency-data/AgencyInterfaces';
import {
    BillingTimeInterval,
    JobberStatus,
    JobberWorkerTypeAgencyPrivateViewDTO,
    JobberWorkerTypeDTO,
    JobberWorkerTypeStatus,
    LaborSalesTaxRuleDTO,
    OrgHourlyRateMarkupType,
} from '../../common/CommonInterfaces';
import { CorpJobberEmploymentDeductionsConfigDTO, ShiftAssignmentConfigRules, ShiftAssignmentConfigRuleType, ShiftAssignmentConfigRuleApplicationType, WorkJurisdictionIdentifier } from '../../orgViews/orgConstants';
import {
    formatWorkJurisdictionLabel,
    listWorkerInviteWorkJurisdictionIdentifiers,
    resolveInviteEmploymentDeductionConfigs,
} from '../../common/WorkJurisdictionTimezoneUtils';
import { ServerResponse, RemoteExecutionServiceImpl } from '../../remoteExecution/RemoteExecutionServiceImpl';
import { WorkyQuickActionsAddWorkerTypeModal } from './AgencyActions';
import { WorkyNavigation } from '../agency-components/WorkyNavigation';
import { DEFAULT_COMMON_ADDRESS } from '../../common/CommonDataConstants';
import { ToolTipCommonComponent } from '../../common/CommonComponents';
import { CLIENT_FACING_WORKER_PROFILE_SECTION_TOOLTIPS } from '../agency-data/AgencyWorkerProfileSectionTooltips';
import {
  CLIENT_BILLING_WORKER_TYPE_NAME_LABEL,
  CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS,
  DEFAULT_JOBBER_PAY_RATE_LABEL,
  DEFAULT_ORG_BILLING_MARKUP_PERCENTAGE_RATE_LABEL,
  DEFAULT_ORG_BILLING_PAY_RATE_LABEL,
  RATE_MARKUP_TYPE_LABEL,
  WORKER_TYPE_DESCRIPTION_LABEL,
  WORKER_TYPE_EDIT_DISPLAY_NAME_MENU_LABEL,
  WORKER_TYPE_EDIT_PAY_AND_BILLING_RATES_MENU_LABEL,
  WORKER_TYPE_EDIT_TAX_MENU_LABEL,
} from '../agency-data/AgencyOrgWorkerTypeClientTooltips';
import { SetJobberWorkerTypeDetailsComponent } from './AgencyActions';
import { buildAgencyJobberDetailsUrl } from './JobberWorkforceNavigationUtils';
import { WorkforceAttributeSearchFilter } from '../agency-attributes/components/WorkforceAttributeSearchFilter';
import { LaborSalesTaxRulesEditor } from '../agency-components/LaborSalesTaxRulesEditor';
import { LaborSalesTaxRulesSummary } from '../agency-components/LaborSalesTaxRulesSummary';

// CSS Imports
import '../../orgViews/myworkforce.css';
import '../../orgViews/orgworkforcejobbermodal.css';
import './agencyactions.css';
import './agencybilling2.css';


const defaultPic = '/org-default-icon.png';

const DEFAULT_WORKFORCE_STATUS_FILTER: readonly JobberStatus[] = [
    JobberStatus.REGISTERED_BY_ORG_AGENCY_NEEDS_TO_ON_BOARD,
    JobberStatus.REGISTERED_ON_COGNITO_COMPLETED,
    JobberStatus.REGISTERED_NEEDS_TO_COMPLETE_ONBOARDING_TEMPLATE,
    JobberStatus.REGISTERED_SUBMITTED_JOBBER_REG_FORM,
    JobberStatus.FULLY_HIRED,
];

const FILTERABLE_JOBBER_STATUSES: readonly JobberStatus[] = [
    JobberStatus.REGISTERED_BY_ORG_AGENCY_NEEDS_TO_ON_BOARD,
    JobberStatus.REGISTERED_ON_COGNITO_COMPLETED,
    JobberStatus.REGISTERED_NEEDS_TO_COMPLETE_ONBOARDING_TEMPLATE,
    JobberStatus.REGISTERED_SUBMITTED_JOBBER_REG_FORM,
    JobberStatus.FULLY_HIRED,
    JobberStatus.CANCELLED,
];

const CrudMyWorkerTypes = ({ isMobile, agencyData }: { isMobile: boolean, agencyData: AgencyObjClient | null }) => {
  const [expandedWorkerTypeId, setExpandedWorkerTypeId] = useState<string | null>(null);
  const [editingWorkerTypeId, setEditingWorkerTypeId] = useState<string | null>(null);
  const [editingWorkerTypeFormData, setEditingWorkerTypeFormData] = useState<CreateOrgForAgencyFormData | null>(null);
  const [isUpdatingPayRate, setIsUpdatingPayRate] = useState(false);
  const [editingOrgBillingWorkerTypeId, setEditingOrgBillingWorkerTypeId] = useState<string | null>(null);
  const [editingOrgBillingNameValue, setEditingOrgBillingNameValue] = useState<string>('');
  const [isUpdatingOrgBillingName, setIsUpdatingOrgBillingName] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [statusUpdatingWorkerTypeId, setStatusUpdatingWorkerTypeId] = useState<string | null>(null);
  const [laborSalesTaxEditingWorkerType, setLaborSalesTaxEditingWorkerType] =
    useState<JobberWorkerTypeAgencyPrivateViewDTO | null>(null);
  const [isSavingLaborSalesTax, setIsSavingLaborSalesTax] = useState(false);
  const [workerTypeEditMenuAnchorEl, setWorkerTypeEditMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [workerTypeEditMenuWorkerType, setWorkerTypeEditMenuWorkerType] =
    useState<JobberWorkerTypeAgencyPrivateViewDTO | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  const isWorkerTypeEditMenuOpen: boolean = Boolean(workerTypeEditMenuAnchorEl);

  const handleCloseWorkerTypeEditMenu = (): void => {
    setWorkerTypeEditMenuAnchorEl(null);
    setWorkerTypeEditMenuWorkerType(null);
  };

  const allWorkerTypes: readonly JobberWorkerTypeAgencyPrivateViewDTO[] = useMemo(() => {
    return (agencyData?.jobberWorkerTypes || []).slice().sort((a, b) => a.workerTypeName.localeCompare(b.workerTypeName));
  }, [agencyData?.jobberWorkerTypes]);

  const workerTypes: readonly JobberWorkerTypeAgencyPrivateViewDTO[] = useMemo(() => {
    if (!searchTerm.trim()) {
      return allWorkerTypes;
    }
    const lowerSearchTerm: string = searchTerm.toLowerCase().trim();
    return allWorkerTypes.filter((workerType) => 
      workerType.workerTypeName.toLowerCase().includes(lowerSearchTerm)
    );
  }, [allWorkerTypes, searchTerm]);

  const toggleAccordion = (id: string) => {
    setExpandedWorkerTypeId(prevId => (prevId === id ? null : id));
  };

  const markupTypeDisplayValues: Record<OrgHourlyRateMarkupType, string> = {
    [OrgHourlyRateMarkupType.PERCENTAGE_RATE_MARKUP_TYPE]: 'Percent Markup',
    [OrgHourlyRateMarkupType.DEFAULT_CONFIGURED_HOURLY_RATE_MARKUP_TYPE]: 'Default Hourly Markup',
    [OrgHourlyRateMarkupType.HOURLY_RATE_MARKUP_TYPE]: 'Hourly Markup'
  };

  const handleEditPayRate = (workerType: JobberWorkerTypeAgencyPrivateViewDTO) => {
    const formData: CreateOrgForAgencyFormData = {
      orgName: '',
      locationAddress: DEFAULT_COMMON_ADDRESS,
      managerName: '',
      managerEmail: '',
      managerPhoneNum: '',
      orgLocationClient: [],
      billingInterval: BillingTimeInterval.MONTHLY,
      billingDay: '',
      billingCycleAnchorDate: '',
      workerType: [{        
        workerTypeName: workerType.workerTypeName,
        workerTypeUniqueIdentifier: workerType.workerTypeUniqueIdentifier,
        defaultJobberPayRate: workerType.defaultJobberPayRate,
        orgHourlyRateMarkupType: workerType.orgHourlyRateMarkupType,
        defaultOrgBillingPayRate: workerType.defaultOrgBillingPayRate
      }]
    };

    setEditingWorkerTypeId(workerType.workerTypeUniqueIdentifier);
    setEditingWorkerTypeFormData(formData);
  };

  const handleCancelEditPayRate = () => {
    setEditingWorkerTypeId(null);
    setEditingWorkerTypeFormData(null);
  };

  const handleStartEditOrgBillingName = (workerType: JobberWorkerTypeAgencyPrivateViewDTO) => {
    setEditingOrgBillingWorkerTypeId(workerType.workerTypeUniqueIdentifier);
    setEditingOrgBillingNameValue(workerType.orgBillingWorkerTypeName ?? '');
  };

  const handleCancelEditOrgBillingName = () => {
    setEditingOrgBillingWorkerTypeId(null);
    setEditingOrgBillingNameValue('');
  };

  const handleSaveOrgBillingName = async (workerTypeUniqueIdentifier: string) => {
    setIsUpdatingOrgBillingName(true);
    try {
      const orgBillingWorkerTypeName = editingOrgBillingNameValue.trim() || null;
      const response = await UpdateOrgBillingWorkerTypeName({
        workerTypeUniqueIdentifier,
        orgBillingWorkerTypeName
      });
      if (response) {
        enqueueSnackbar('Client billing worker type name updated successfully.', { variant: 'success' });
        setEditingOrgBillingWorkerTypeId(null);
        setEditingOrgBillingNameValue('');
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        enqueueSnackbar('Failed to update client billing worker type name. Please try again.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating org billing worker type name:', error);
      enqueueSnackbar('An error occurred while updating the client billing worker type name.', { variant: 'error' });
    } finally {
      setIsUpdatingOrgBillingName(false);
    }
  };

  const handleWorkerTypeStatusChange = async (
    workerType: JobberWorkerTypeAgencyPrivateViewDTO,
    nextStatus: JobberWorkerTypeStatus
  ): Promise<void> => {
    setStatusUpdatingWorkerTypeId(workerType.workerTypeUniqueIdentifier);
    try {
      const updatedAgency = await UpdateJobberWorkerTypeStatusAPICall({
        workerTypeUniqueIdentifier: workerType.workerTypeUniqueIdentifier,
        status: nextStatus,
      });
      if (updatedAgency) {
        enqueueSnackbar(
          nextStatus === JobberWorkerTypeStatus.DISABLED
            ? 'Worker type disabled'
            : 'Worker type enabled',
          { variant: 'success' }
        );
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        enqueueSnackbar('Could not update worker type status', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating jobber worker type status:', error);
      enqueueSnackbar('Could not update worker type status', { variant: 'error' });
    } finally {
      setStatusUpdatingWorkerTypeId(null);
    }
  };

  const handleSavePayRate = async () => {
    if (!editingWorkerTypeFormData || !editingWorkerTypeFormData.workerType?.[0] || !agencyData) {
      enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
      return;
    }

    const workerTypeData = editingWorkerTypeFormData.workerType[0];

    setIsUpdatingPayRate(true);
    try {
      const createJobberWorkerTypeDTO: CreateJobberWorkerTypeDTO = {
        workerTypeName: workerTypeData.workerTypeName,
        workerTypeUniqueIdentifier: workerTypeData.workerTypeUniqueIdentifier,
        defaultJobberPayRate: workerTypeData.defaultJobberPayRate,
        orgHourlyRateMarkupType: workerTypeData.orgHourlyRateMarkupType,
        orgHourlyRateMarkupTypeValue: workerTypeData.defaultOrgBillingPayRate
      };

      const payload: UpdateDefaultWorkerTypePayRateRequestDTO = {
        workerTypeUniqueIdentifier: workerTypeData.workerTypeUniqueIdentifier,
        createJobberWorkerTypeDTO: createJobberWorkerTypeDTO
      };

      const response = await UpdateDefaultWorkerTypePayRate(payload);
      if (response) {
        enqueueSnackbar('Worker type updated successfully!', { variant: 'success' });
        setEditingWorkerTypeId(null);
        setEditingWorkerTypeFormData(null);
        // Refresh the page to show updated data
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        enqueueSnackbar('Failed to update worker type. Please try again.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating worker type:', error);
      enqueueSnackbar('An error occurred while updating the worker type.', { variant: 'error' });
    } finally {
      setIsUpdatingPayRate(false);
    }
  };

  if (!agencyData) {
    return (
      <div className={isMobile ? 'general-info-holder-mobile-alt' : 'account-settings-crud-part-inner'}>
        <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
          Loading agency data...
        </div>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%',
      padding: isMobile ? '0' : '0'
    }}>
      {/* Search Input */}
      <div style={{
        marginBottom: '20px',
        position: 'relative'
      }}>
        <input
          type="text"
          placeholder="Search worker types..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '12px 16px 12px 42px',
            fontSize: '14px',
            border: '1px solid #e5e7eb',
            borderRadius: '10px',
            outline: 'none',
            transition: 'all 0.2s ease',
            background: 'white',
            color: '#1f2937'
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = '#2c68bd';
            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(44, 104, 189, 0.1)';
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = '#e5e7eb';
            e.currentTarget.style.boxShadow = 'none';
          }}
        />
        <div style={{
          position: 'absolute',
          left: '14px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#9ca3af',
          pointerEvents: 'none'
        }}>
          <svg 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
        </div>
        {searchTerm && (
          <button
            onClick={() => setSearchTerm('')}
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#9ca3af',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#ef4444';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#9ca3af';
            }}
            title="Clear search"
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        )}
      </div>

      {/* Worker Types Grid */}
      {workerTypes.length > 0 ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          {workerTypes.map((workerType, index) => {
            const uniqueId = workerType.workerTypeUniqueIdentifier || String(index);
            const isExpanded = expandedWorkerTypeId === uniqueId;
            const isActive: boolean = isJobberWorkerTypeActive(workerType);
            const isUpdatingStatus: boolean = statusUpdatingWorkerTypeId === uniqueId;
            const nextStatus: JobberWorkerTypeStatus = isActive
              ? JobberWorkerTypeStatus.DISABLED
              : JobberWorkerTypeStatus.ACTIVE;

            return (
              <div
                key={uniqueId}
                style={{
                  background: isActive ? 'white' : '#f8fafc',
                  border: `1px solid ${isExpanded ? '#2c68bd' : isActive ? '#e5e7eb' : '#e2e8f0'}`,
                  borderRadius: '12px',
                  overflow: 'hidden',
                  transition: 'all 0.2s ease',
                  boxShadow: isExpanded ? '0 4px 12px rgba(44, 104, 189, 0.1)' : '0 1px 3px rgba(0, 0, 0, 0.05)'
                }}
              >
                <div
                  onClick={() => toggleAccordion(uniqueId)}
                  style={{
                    padding: '16px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    background: isExpanded ? '#f8fafc' : 'white',
                    transition: 'background 0.2s ease',
                    userSelect: 'none'
                  }}
                  onMouseEnter={(e) => {
                    if (!isExpanded) {
                      e.currentTarget.style.background = '#f9fafb';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isExpanded) {
                      e.currentTarget.style.background = 'white';
                    }
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '10px',
                      background: isExpanded ? '#2c68bd' : '#f3f4f6',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.2s ease'
                    }}>
                      <UserRoundCog size={20} color={isExpanded ? 'white' : '#4c4c4c'} />
                    </div>
                    <div style={{
                      fontSize: '16px',
                      fontWeight: 600,
                      color: '#1f2937',
                      letterSpacing: '-0.01em'
                    }}>
                      {workerType.workerTypeName}
                      {!isActive ? (
                        <span className="wgc-template-card-status-badge" style={{ marginLeft: '8px' }}>
                          Disabled
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Tooltip
                      title={
                        isUpdatingStatus
                          ? 'Updating worker type status…'
                          : isActive
                            ? 'Disable this worker type — hidden from shift creation and org assignment pickers'
                            : 'Enable this worker type again'
                      }
                      placement="top"
                      arrow
                    >
                      <span>
                        <button
                          type="button"
                          className={`wgc-template-card-status-btn${
                            isActive
                              ? ' wgc-template-card-status-btn-disable'
                              : ' wgc-template-card-status-btn-enable'
                          }`}
                          disabled={isUpdatingStatus}
                          onClick={(e) => {
                            e.stopPropagation();
                            void handleWorkerTypeStatusChange(workerType, nextStatus);
                          }}
                        >
                          {isUpdatingStatus ? 'Updating…' : isActive ? 'Disable' : 'Enable'}
                        </button>
                      </span>
                    </Tooltip>
                    <div style={{
                      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s ease',
                      color: '#6b7280'
                    }}>
                      <ChevronDown size={20} />
                    </div>
                  </div>
                </div>

                {isExpanded && (
                  <div style={{
                    padding: '20px',
                    background: '#fafbfc',
                    borderTop: '1px solid #e5e7eb'
                  }}>
                    {editingWorkerTypeId === uniqueId && editingWorkerTypeFormData && agencyData ? (
                      <div style={{
                        padding: '24px',
                        background: 'white',
                        border: '2px solid #2c68bd',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(44, 104, 189, 0.1)'
                      }}>
                        <div style={{
                          marginBottom: '20px',
                          fontSize: '18px',
                          fontWeight: 700,
                          color: '#2c68bd',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <ModeRoundedIcon sx={{ fontSize: '20px' }} />
                          Edit Worker Type: {workerType.workerTypeName}
                        </div>
                        <SetJobberWorkerTypeDetailsComponent
                          agencyData={agencyData}
                          formData={editingWorkerTypeFormData}
                          setFormData={setEditingWorkerTypeFormData}
                        />
                        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                          <button
                            onClick={handleSavePayRate}
                            disabled={isUpdatingPayRate || !editingWorkerTypeFormData.workerType?.[0]?.defaultJobberPayRate}
                            style={{
                              flex: 1,
                              padding: '12px 24px',
                              background: '#2c68bd',
                              color: 'white',
                              border: 'none',
                              borderRadius: '8px',
                              fontSize: '14px',
                              fontWeight: 600,
                              cursor: isUpdatingPayRate || !editingWorkerTypeFormData.workerType?.[0]?.defaultJobberPayRate ? 'not-allowed' : 'pointer',
                              opacity: isUpdatingPayRate || !editingWorkerTypeFormData.workerType?.[0]?.defaultJobberPayRate ? 0.6 : 1,
                              transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (!isUpdatingPayRate && editingWorkerTypeFormData.workerType?.[0]?.defaultJobberPayRate) {
                                e.currentTarget.style.background = '#1e4d8c';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = '#2c68bd';
                              e.currentTarget.style.transform = 'translateY(0)';
                            }}
                          >
                            {isUpdatingPayRate ? 'Saving...' : 'Save Changes'}
                          </button>
                          <button
                            onClick={handleCancelEditPayRate}
                            disabled={isUpdatingPayRate}
                            style={{
                              flex: 1,
                              padding: '12px 24px',
                              background: 'white',
                              color: '#374151',
                              border: '1px solid #d1d5db',
                              borderRadius: '8px',
                              fontSize: '14px',
                              fontWeight: 600,
                              cursor: isUpdatingPayRate ? 'not-allowed' : 'pointer',
                              opacity: isUpdatingPayRate ? 0.6 : 1,
                              transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (!isUpdatingPayRate) {
                                e.currentTarget.style.background = '#f9fafb';
                                e.currentTarget.style.borderColor = '#9ca3af';
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'white';
                              e.currentTarget.style.borderColor = '#d1d5db';
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '16px',
                          padding: '16px',
                          background: 'white',
                          borderRadius: '8px',
                          border: '1px solid #e5e7eb'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            paddingBottom: '12px',
                            borderBottom: '1px solid #f3f4f6'
                          }}>
                            <ToolTipCommonComponent
                              toolTipText={CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.defaultJobberPayRate}
                            >
                              <div style={{ fontSize: '14px', fontWeight: 600, color: '#2c68bd' }}>
                                {DEFAULT_JOBBER_PAY_RATE_LABEL}
                              </div>
                            </ToolTipCommonComponent>
                            <div style={{ fontSize: '16px', fontWeight: 700, color: '#1f2937' }}>
                              ${workerType.defaultJobberPayRate}/hr
                            </div>
                          </div>

                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            paddingBottom: '12px',
                            borderBottom: '1px solid #f3f4f6'
                          }}>
                            <ToolTipCommonComponent
                              toolTipText={CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.getMarkupTypeTooltipText(
                                workerType.orgHourlyRateMarkupType
                              )}
                            >
                              <div style={{ fontSize: '14px', fontWeight: 600, color: '#2c68bd' }}>
                                {RATE_MARKUP_TYPE_LABEL}
                              </div>
                            </ToolTipCommonComponent>
                            <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
                              {markupTypeDisplayValues[workerType.orgHourlyRateMarkupType] || workerType.orgHourlyRateMarkupType}
                            </div>
                          </div>

                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            paddingBottom: '12px',
                            borderBottom: '1px solid #f3f4f6'
                          }}>
                            <ToolTipCommonComponent
                              toolTipText={
                                workerType.orgHourlyRateMarkupType === OrgHourlyRateMarkupType.PERCENTAGE_RATE_MARKUP_TYPE
                                  ? CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.defaultOrgBillingMarkupPercentageRate
                                  : CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.defaultOrgBillingPayRate
                              }
                            >
                              <div style={{ fontSize: '14px', fontWeight: 600, color: '#2c68bd' }}>
                                {workerType.orgHourlyRateMarkupType === OrgHourlyRateMarkupType.PERCENTAGE_RATE_MARKUP_TYPE
                                  ? DEFAULT_ORG_BILLING_MARKUP_PERCENTAGE_RATE_LABEL
                                  : DEFAULT_ORG_BILLING_PAY_RATE_LABEL}
                              </div>
                            </ToolTipCommonComponent>
                            <div style={{ fontSize: '16px', fontWeight: 700, color: '#1f2937' }}>
                              {workerType.orgHourlyRateMarkupType === OrgHourlyRateMarkupType.PERCENTAGE_RATE_MARKUP_TYPE
                                ? `${workerType.defaultOrgBillingPayRate}%`
                                : `$${workerType.defaultOrgBillingPayRate}/hr`}
                            </div>
                          </div>

                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            paddingBottom: '12px',
                            borderBottom: '1px solid #f3f4f6'
                          }}>
                            <ToolTipCommonComponent
                              toolTipText={CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.clientBillingWorkerTypeName}
                            >
                              <div style={{ fontSize: '14px', fontWeight: 600, color: '#2c68bd' }}>
                                {CLIENT_BILLING_WORKER_TYPE_NAME_LABEL}
                              </div>
                            </ToolTipCommonComponent>
                            {editingOrgBillingWorkerTypeId === workerType.workerTypeUniqueIdentifier ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, maxWidth: '320px' }}>
                                <TextField
                                  size="small"
                                  value={editingOrgBillingNameValue}
                                  onChange={(e) => setEditingOrgBillingNameValue(e.target.value)}
                                  placeholder="Billing name (optional)"
                                  fullWidth
                                  inputProps={{ style: { fontSize: '14px' } }}
                                />
                                <Tooltip title="Save">
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => handleSaveOrgBillingName(workerType.workerTypeUniqueIdentifier)}
                                    disabled={isUpdatingOrgBillingName}
                                  >
                                    <CheckRoundedIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Cancel">
                                  <IconButton
                                    size="small"
                                    onClick={handleCancelEditOrgBillingName}
                                    disabled={isUpdatingOrgBillingName}
                                  >
                                    <CancelRoundedIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            ) : (
                              <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
                                {isValidString(workerType.orgBillingWorkerTypeName) ? workerType.orgBillingWorkerTypeName : 'Not set'}
                              </div>
                            )}
                          </div>

                          <LaborSalesTaxRulesSummary
                            laborSalesTaxRules={workerType.laborSalesTaxRules}
                            layout="cardRows"
                          />

                          {(workerType as any).description && (
                            <div style={{
                              paddingTop: '12px',
                              borderTop: '1px solid #f3f4f6'
                            }}>
                              <ToolTipCommonComponent
                                toolTipText={CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.description}
                              >
                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#2c68bd', marginBottom: '4px' }}>
                                  {WORKER_TYPE_DESCRIPTION_LABEL}
                                </div>
                              </ToolTipCommonComponent>
                              <div style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.5' }}>
                                {(workerType as any).description}
                              </div>
                            </div>
                          )}
                        </div>

                        <div style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          gap: '8px',
                          marginTop: '16px'
                        }}>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setWorkerTypeEditMenuAnchorEl(e.currentTarget);
                              setWorkerTypeEditMenuWorkerType(workerType);
                            }}
                            style={{
                              padding: '10px 20px',
                              background: 'white',
                              color: '#2c68bd',
                              border: '1px solid #2c68bd',
                              borderRadius: '8px',
                              fontSize: '14px',
                              fontWeight: 600,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = '#2c68bd';
                              e.currentTarget.style.color = 'white';
                              e.currentTarget.style.transform = 'translateY(-1px)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(44, 104, 189, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'white';
                              e.currentTarget.style.color = '#2c68bd';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                            title="Edit worker type"
                            aria-haspopup="menu"
                            aria-expanded={
                              isWorkerTypeEditMenuOpen
                              && workerTypeEditMenuWorkerType?.workerTypeUniqueIdentifier
                                === workerType.workerTypeUniqueIdentifier
                            }
                          >
                            <ModeRoundedIcon sx={{ fontSize: '18px' }} />
                            Edit
                            <ChevronDown size={16} />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{
          padding: '40px 20px',
          textAlign: 'center',
          color: '#6b7280',
          background: '#f9fafb',
          borderRadius: '12px',
          border: '1px dashed #d1d5db'
        }}>
          <Users size={48} style={{ color: '#d1d5db', marginBottom: '12px' }} />
          <div style={{ fontSize: '16px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
            {searchTerm ? 'No matching worker types found' : 'No worker types found'}
          </div>
          <div style={{ fontSize: '14px', color: '#6b7280' }}>
            {searchTerm ? `No worker types match "${searchTerm}"` : 'Create your first worker type to get started'}
          </div>
          {searchTerm && (
            <button
              onClick={() => setSearchTerm('')}
              style={{
                marginTop: '16px',
                padding: '8px 16px',
                background: '#2c68bd',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#1e4d8c';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#2c68bd';
              }}
            >
              Clear Search
            </button>
          )}
        </div>
      )}
      <Menu
        anchorEl={workerTypeEditMenuAnchorEl}
        open={isWorkerTypeEditMenuOpen}
        onClose={handleCloseWorkerTypeEditMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            if (workerTypeEditMenuWorkerType != null) {
              setLaborSalesTaxEditingWorkerType(workerTypeEditMenuWorkerType);
            }
            handleCloseWorkerTypeEditMenu();
          }}
        >
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.editTax}
          >
            <span>{WORKER_TYPE_EDIT_TAX_MENU_LABEL}</span>
          </ToolTipCommonComponent>
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (workerTypeEditMenuWorkerType != null) {
              handleStartEditOrgBillingName(workerTypeEditMenuWorkerType);
            }
            handleCloseWorkerTypeEditMenu();
          }}
        >
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.editDisplayName}
          >
            <span>{WORKER_TYPE_EDIT_DISPLAY_NAME_MENU_LABEL}</span>
          </ToolTipCommonComponent>
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (workerTypeEditMenuWorkerType != null) {
              handleEditPayRate(workerTypeEditMenuWorkerType);
            }
            handleCloseWorkerTypeEditMenu();
          }}
        >
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_ORG_WORKER_TYPE_TOOLTIPS.editPayAndBillingRates}
          >
            <span>{WORKER_TYPE_EDIT_PAY_AND_BILLING_RATES_MENU_LABEL}</span>
          </ToolTipCommonComponent>
        </MenuItem>
      </Menu>
      <Dialog
        open={laborSalesTaxEditingWorkerType !== null}
        onClose={() => {
          if (!isSavingLaborSalesTax) {
            setLaborSalesTaxEditingWorkerType(null);
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Sales tax
          {laborSalesTaxEditingWorkerType
            ? ` — ${laborSalesTaxEditingWorkerType.workerTypeName}`
            : ''}
        </DialogTitle>
        <DialogContent>
          {laborSalesTaxEditingWorkerType ? (
            <LaborSalesTaxRulesEditor
              initialRules={laborSalesTaxEditingWorkerType.laborSalesTaxRules}
              helperNote="Agency defaults per worker type and jurisdiction (ON/BC/AB). Client overrides can still apply on the organization page."
              isSaving={isSavingLaborSalesTax}
              onCancel={() => setLaborSalesTaxEditingWorkerType(null)}
              onSave={async (rules: LaborSalesTaxRuleDTO[]) => {
                setIsSavingLaborSalesTax(true);
                try {
                  const response = await UpdateJobberWorkerTypeLaborSalesTax({
                    workerTypeUniqueIdentifier:
                      laborSalesTaxEditingWorkerType.workerTypeUniqueIdentifier,
                    laborSalesTaxRules: rules,
                  });
                  if (response) {
                    enqueueSnackbar('Sales tax updated.', { variant: 'success' });
                    setLaborSalesTaxEditingWorkerType(null);
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                  } else {
                    enqueueSnackbar('Failed to update sales tax.', { variant: 'error' });
                  }
                } finally {
                  setIsSavingLaborSalesTax(false);
                }
              }}
            />
          ) : null}
        </DialogContent>
      </Dialog>
    </div>
  );
};


const copyToClipboard = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      console.log("Copied to clipboard: " + value);
    } catch (err) {
      console.error("Unable to copy to clipboard:", err);
    }
};



const WorkforceTagBuilder = ({ isMobile, timeString, forceMobile = false }: { isMobile: boolean; timeString: string; forceMobile?:boolean }) => {
    if (!timeString) { return null; }
    const displayMobile = forceMobile !== undefined ? forceMobile : isMobile;

    const times = timeString.toString().split(',').map(time => 
      time.trim().toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
    );
  
    return (
      <>
        {times.map((time, index) => {
          // Conditionally render based on time value
          if (time === "Morning") {
            return (
              <div key={index} className="card-availability-icon">
                {displayMobile ? (
                  <LightModeRoundedIcon style={{ fontSize: "14px" }} />
                ) : (
                  <>
                    <LightModeRoundedIcon style={{ fontSize: "14px" }} />
                    Morning
                  </>
                )}
              </div>
            );
          } else if (time === "Noon") {
            return (
              <div key={index} className="card-availability-icon">
                {displayMobile ? (
                  <WbTwilightRoundedIcon style={{ fontSize: "14px" }} />
                ) : (
                  <>
                    <WbTwilightRoundedIcon style={{ fontSize: "14px" }} />
                    Afternoon
                  </>
                )}
              </div>
            );
          } else if (time === "Night") {
            return (
              <div key={index} className="card-availability-icon">
                {displayMobile ? (
                  <NightsStayRoundedIcon style={{ fontSize: "14px" }} />
                ) : (
                  <>
                    <NightsStayRoundedIcon style={{ fontSize: "14px" }} />
                    Night
                  </>
                )}
              </div>
            );
          } else if (time === "Unavailable") { 
            return null;
          }
  
          return (
            <div key={index} className="card-availability-icon">{time}</div>
          );
        })}
      </>
    );
  };

const ChangeJobberStatusModal = ({ isOpen, onClose, jobberEmails, currentStatus, onStatusChanged }: { isOpen: boolean, onClose: () => void, jobberEmails: string[], currentStatus?: JobberStatus, onStatusChanged: () => void }) => {
    const [selectedStatus, setSelectedStatus] = useState<JobberStatus | null>(null);
    const { enqueueSnackbar } = useSnackbar();
    
    const handleStatusChange = async () => {
        if (!selectedStatus) return;
        
        try {
            const req: ChangeJobberStatusReqDTO = {
                jobberEmails: jobberEmails.map(email => ({ value: email })),
                newJobberStatus: selectedStatus
            };
            const res = await ChangeJobberStatusAPICall(req);
            if (res) {
                enqueueSnackbar("Status updated successfully", { variant: "success" });
                onStatusChanged();
                onClose();
            }
        } catch (e) {
            console.error(e);
            enqueueSnackbar("Failed to update status", { variant: "error" });
        }
    };

    const allowedStatuses = [            
        JobberStatus.FULLY_HIRED,
        JobberStatus.CANCELLED
    ];

    return (
        <Modal open={isOpen} onClose={onClose} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
             <div className="wgc-modal-container" style={{width: '500px', maxWidth: '90%', maxHeight: '80vh', overflowY: 'auto', background: 'white', borderRadius: '28px', padding: '20px'}}>
                <div className="wgc-modal-header" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                    <h2 style={{margin: 0, fontSize: '1.25rem', fontWeight: 600}}>Change Status {jobberEmails.length > 1 ? `(${jobberEmails.length} Workers)` : ''}</h2>
                    <button onClick={onClose} className="wgc-modal-close" style={{background: 'none', border: 'none', cursor: 'pointer'}}><X size={24} /></button>
                </div>
                <div className="wgc-modal-body">
                    {jobberEmails.length === 1 && (
                    <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f3f4f6', borderRadius: '6px' }}>
                        <span style={{ fontWeight: 600, color: '#374151' }}>Current Status: </span>
                        {/* <span style={{ color: '#1f2937' }}>{currentStatus}</span> */}
                        <p style={{ margin: '5px 0 0 0', fontSize: '0.875rem', color: '#6b7280' }}>
                            {getJobberStatusMessageForReadOnly(currentStatus)}
                        </p>
                    </div>
                    )}
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {allowedStatuses.map(status => (
                            <div key={status} 
                                style={{ 
                                    padding: "15px", 
                                    border: selectedStatus === status ? "2px solid #2c68bd" : "1px solid #e5e7eb",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    backgroundColor: selectedStatus === status ? "#f0f7ff" : "white"
                                }}
                                onClick={() => setSelectedStatus(status)}
                            >
                                {status === JobberStatus.FULLY_HIRED ? (
                                    <ToolTipCommonComponent
                                        toolTipText={CLIENT_FACING_WORKER_PROFILE_SECTION_TOOLTIPS.fullyHiredStatus}
                                    >
                                        <strong style={{display: 'block', marginBottom: '5px'}}>{status}</strong>
                                    </ToolTipCommonComponent>
                                ) : (
                                    <strong style={{display: 'block', marginBottom: '5px'}}>{status}</strong>
                                )}
                                <p style={{margin: 0, color: '#6b7280', fontSize: '14px'}}>{getJobberStatusMessageForReadOnly(status)}</p>
                            </div>
                        ))}
                    </div>
                    <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                        <button 
                            onClick={handleStatusChange} 
                            disabled={!selectedStatus}
                            className="worky-actions-btn-v2"
                            style={{
                                opacity: !selectedStatus ? 0.5 : 1,
                                cursor: !selectedStatus ? 'not-allowed' : 'pointer',
                                height: '40px',
                                paddingLeft: '20px', 
                                paddingRight: '20px'
                            }}
                        >
                            Confirm Status Change
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};


const AddNewWorkerModal = ({ isOpen, onClose, availableWorkerTypes, agencyData }: { isOpen: boolean, onClose: () => void, availableWorkerTypes: JobberWorkerTypeAgencyPrivateViewDTO[], agencyData: AgencyObjClient | null }) => {
    const isMobile = useIsMobile();
    const { enqueueSnackbar } = useSnackbar();
    const [email, setEmail] = useState<string>('');
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [workerTypes, setWorkerTypes] = useState<Array<{ workerTypeName: string; payRate: string }>>([]);
    const [selectedJurisdiction, setSelectedJurisdiction] = useState<string>('');
    const [selectedEmploymentDeductionConfig, setSelectedEmploymentDeductionConfig] = useState<CorpJobberEmploymentDeductionsConfigDTO | null>(null);
    const [templates, setTemplates] = useState<WorkTaskTemplateResponseDTO[]>([]);
    const [selectedTemplateId, setSelectedTemplateId] = useState<string>('');

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const templatesData = await GetJobberOnboardingTemplatesAPICall();
                if (templatesData) {
                    setTemplates(templatesData);
                }
            } catch (error) {
                console.error('Error fetching templates:', error);
            }
        };

        if (isOpen) {
            fetchTemplates();
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) {
            // Reset form when modal closes
            setEmail('');
            setPhoneNumber('');
            setWorkerTypes([]);
            setSelectedJurisdiction('');
            setSelectedEmploymentDeductionConfig(null);
            setSelectedTemplateId('');
        }
    }, [isOpen]);

    const handleAddWorkerType = () => {
        setWorkerTypes([...workerTypes, { workerTypeName: '', payRate: '' }]);
    };

    const handleRemoveWorkerType = (index: number) => {
        setWorkerTypes(workerTypes.filter((_, i) => i !== index));
    };

    const handleWorkerTypeChange = (index: number, field: 'workerTypeName' | 'payRate', value: string) => {
        const updated = [...workerTypes];
        updated[index] = { ...updated[index], [field]: value };
        
        // If worker type name is being changed, set the default pay rate
        if (field === 'workerTypeName' && value) {
            const selectedType = availableWorkerTypes.find(type => type.workerTypeName === value);
            if (selectedType) {
                updated[index].payRate = selectedType.defaultJobberPayRate.toString();
            }
        }
        
        setWorkerTypes(updated);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!email) {
            enqueueSnackbar('Please enter an email address', { variant: 'warning' });
            return;
        }

        try {
            const request: RegisterJobberRequestSimpleDTO = {
                jobberEmailAddress: email,
                jobberPhoneNumber: phoneNumber || undefined,
                jobberWorkerTypes: workerTypes.length > 0 ? workerTypes
                    .filter(wt => wt.workerTypeName && wt.payRate)
                    .map(wt => ({
                        jobberWorkerTypeName: wt.workerTypeName,
                        jobberWorkerTypeNameDefaultPayRate: Number(wt.payRate)
                    })) : undefined,
                corpJobberEmploymentId: selectedEmploymentDeductionConfig.corpJobberEmploymentId,
                workJurisdictionIdentifier: selectedJurisdiction,
                templateId: selectedTemplateId || undefined
            };

            const result = await RegisterBulkJobbersPOSTAPICall([request]);
            if (result) {
                enqueueSnackbar('Worker added successfully', { variant: 'success' });
                setEmail('');
                setPhoneNumber('');
                setWorkerTypes([]);
                onClose();
            }
        } catch (error) {
            console.error('Error adding worker:', error);
            enqueueSnackbar('Failed to add worker', { variant: 'error' });
        }
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    backdropFilter: 'blur(4px)'
                }
            }}
        >
            <Slide direction={isMobile ? 'up' : 'left'} in={isOpen} mountOnEnter unmountOnExit>
                <div
                    className={isMobile ? 'agency-billing-modal-mobile' : 'agency-billing-modal'}
                    style={{
                        width: '100%',
                        maxWidth: '700px',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        borderRadius: isMobile ? '20px 20px 0 0' : '16px',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                        background: 'white',
                        position: 'relative'
                    }}
                >
                    {/* Header */}
                    <div style={{
                        position: 'sticky',
                        top: 0,
                        background: 'white',
                        zIndex: 10,
                        padding: isMobile ? '20px 20px 15px 20px' : '20px 24px 16px 24px',
                        borderBottom: '1px solid #e5e7eb',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <div>
                            <h2 style={{
                                margin: 0,
                                fontSize: isMobile ? '20px' : '24px',
                                fontWeight: 700,
                                color: '#1f2937',
                                letterSpacing: '-0.02em'
                            }}>
                                Add New Worker
                            </h2>
                            <p style={{
                                margin: '4px 0 0 0',
                                fontSize: '14px',
                                color: '#6b7280',
                                fontWeight: 400
                            }}>
                                Manually add a new worker to your workforce
                            </p>
                        </div>
                        {isMobile ? (
                            <button
                                onClick={onClose}
                                className='timeclock-close-mobile'
                                style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '20px'
                                }}
                            />
                        ) : (
                            <button
                                onClick={onClose}
                                style={{
                                    background: '#f3f4f6',
                                    border: 'none',
                                    borderRadius: '8px',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: '#6b7280'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = '#e5e7eb';
                                    e.currentTarget.style.color = '#1f2937';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = '#f3f4f6';
                                    e.currentTarget.style.color = '#6b7280';
                                }}
                            >
                                <CloseRoundedIcon />
                            </button>
                        )}
                    </div>

                    {/* Content */}
                    <div style={{
                        padding: isMobile ? '20px' : '20px 24px 24px 24px'
                    }}>
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <div>
                                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 600, color: '#374151' }}>
                                    Email Address <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email address"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '14px',
                                        color: '#1f2937',
                                        outline: 'none',
                                        transition: 'border-color 0.2s',
                                        boxSizing: 'border-box'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#2c68bd'}
                                    onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                                />
                            </div>

                            <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '20px' }}>
                                <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
                                    Employment Details
                                </h3>
                                
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#4b5563' }}>
                                            Jurisdiction
                                        </label>
                                        <select
                                            value={selectedJurisdiction}
                                            onChange={(e) => {
                                                setSelectedJurisdiction(e.target.value);
                                                setSelectedEmploymentDeductionConfig(null);
                                            }}
                                            style={{
                                                width: '100%',
                                                padding: '10px 12px',
                                                borderRadius: '8px',
                                                border: '1px solid #d1d5db',
                                                fontSize: '14px',
                                                color: '#1f2937',
                                                outline: 'none',
                                                backgroundColor: 'white',
                                                cursor: 'pointer',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            <option value="">Select Jurisdiction</option>
                                            {listWorkerInviteWorkJurisdictionIdentifiers(
                                                agencyData?.workyPayCorpConfig
                                            ).map((jurisdiction: WorkJurisdictionIdentifier) => (
                                                <option key={jurisdiction} value={jurisdiction}>
                                                    {formatWorkJurisdictionLabel(jurisdiction)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {selectedJurisdiction && resolveInviteEmploymentDeductionConfigs(
                                        agencyData?.workyPayCorpConfig,
                                        selectedJurisdiction
                                    ).length > 0 && (
                                        <div>
                                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#4b5563' }}>
                                                Employment Deduction Config
                                            </label>
                                            <select
                                                value={selectedEmploymentDeductionConfig?.corpJobberEmploymentId || ''}
                                                onChange={(e) => {
                                                    const configs = resolveInviteEmploymentDeductionConfigs(
                                                        agencyData?.workyPayCorpConfig,
                                                        selectedJurisdiction
                                                    );
                                                    const selected = configs.find(config => config.corpJobberEmploymentId === e.target.value);
                                                    setSelectedEmploymentDeductionConfig(selected || null);
                                                }}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px 12px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #d1d5db',
                                                    fontSize: '14px',
                                                    color: '#1f2937',
                                                    outline: 'none',
                                                    backgroundColor: 'white',
                                                    cursor: 'pointer',
                                                    boxSizing: 'border-box'
                                                }}
                                            >
                                                <option value="">Select Employment Deduction Config</option>
                                                {resolveInviteEmploymentDeductionConfigs(
                                                    agencyData?.workyPayCorpConfig,
                                                    selectedJurisdiction
                                                ).map((config) => (
                                                    <option key={config.corpJobberEmploymentId} value={config.corpJobberEmploymentId}>
                                                        {config.corpJobberEmploymentTypeName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 600, color: '#374151' }}>
                                    Onboarding Template (Optional)
                                </label>
                                <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#6b7280' }}>
                                    Select a template for the worker to complete during onboarding
                                </p>
                                <select
                                    value={selectedTemplateId}
                                    onChange={(e) => setSelectedTemplateId(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '14px',
                                        color: '#1f2937',
                                        outline: 'none',
                                        backgroundColor: 'white',
                                        cursor: 'pointer',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <option value="">No Template</option>
                                    {templates.map((template) => (
                                        <option key={template.templateId} value={template.templateId}>
                                            {template.templateName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                    <div>
                                        <h3 style={{ margin: '0', fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
                                            Worker Types (Optional)
                                        </h3>
                                        <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#6b7280' }}>
                                            Add worker types and pay rates
                                        </p>
                                    </div>
                                    <Button
                                        onClick={handleAddWorkerType}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<Plus size={16} />}
                                        style={{
                                            borderColor: '#2c68bd',
                                            color: '#2c68bd',
                                            textTransform: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        Add Type
                                    </Button>
                                </div>
                                
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {workerTypes.map((workerType, index) => (
                                        <div key={index} style={{ 
                                            padding: '16px', 
                                            border: '1px solid #e5e7eb', 
                                            borderRadius: '12px',
                                            backgroundColor: '#f9fafb'
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                                <span style={{ fontSize: '14px', fontWeight: 600, color: '#374151' }}>
                                                    Worker Type {index + 1}
                                                </span>
                                                <Button
                                                    variant="text"
                                                    color="error"
                                                    size="small"
                                                    onClick={() => handleRemoveWorkerType(index)}
                                                    style={{ minWidth: 'auto', padding: '4px 8px', textTransform: 'none' }}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                            
                                            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '16px' }}>
                                                <div>
                                                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 500, color: '#4b5563' }}>
                                                        Type
                                                    </label>
                                                    <select
                                                        value={workerType.workerTypeName}
                                                        onChange={(e) => handleWorkerTypeChange(index, 'workerTypeName', e.target.value)}
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px 10px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #d1d5db',
                                                            fontSize: '14px',
                                                            backgroundColor: 'white',
                                                            outline: 'none',
                                                            boxSizing: 'border-box'
                                                        }}
                                                    >
                                                        <option value="">Select Type</option>
                                                        {availableWorkerTypes.map((type) => (
                                                            <option key={type.workerTypeUniqueIdentifier} value={type.workerTypeName}>
                                                                {type.workerTypeName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}>
                                                        <label style={{ fontSize: '13px', fontWeight: 500, color: '#4b5563' }}>
                                                            Pay Rate ($/hr)
                                                        </label>
                                                        <Tooltip 
                                                            title="The hourly rate that will be paid to the worker for this worker type" 
                                                            placement="top"
                                                            arrow
                                                        >
                                                            <Info size={14} color="#9ca3af" style={{ cursor: 'help' }} />
                                                        </Tooltip>
                                                    </div>
                                                    <WorkyNumberInput
                                                        value={workerType.payRate}
                                                        onChange={(e) => handleWorkerTypeChange(index, 'payRate', e.target.value)}
                                                        placeholder="0.00"
                                                        min="0"
                                                        step="0.01"
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px 10px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #d1d5db',
                                                            fontSize: '14px',
                                                            outline: 'none',
                                                            boxSizing: 'border-box'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    
                                    {workerTypes.length === 0 && (
                                        <div style={{ 
                                            padding: '24px', 
                                            textAlign: 'center', 
                                            background: '#f9fafb', 
                                            borderRadius: '8px', 
                                            border: '1px dashed #d1d5db',
                                            color: '#6b7280',
                                            fontSize: '14px'
                                        }}>
                                            No worker types added yet
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    style={{
                                        backgroundColor: '#2c68bd',
                                        color: 'white',
                                        textTransform: 'none',
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        padding: '12px',
                                        borderRadius: '8px',
                                        boxShadow: 'none'
                                    }}
                                >
                                    Create Worker
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </Slide>
        </Modal>
    );
};

const ViewWorkerTypesModal = ({ isOpen, onClose, isMobile, agencyData, onCreateWorkerType }: { isOpen: boolean, onClose: () => void, isMobile: boolean, agencyData: AgencyObjClient | null, onCreateWorkerType?: () => void }) => {
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="view-worker-types-modal-title"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                className="wgc-modal"
                style={{
                    width: isMobile ? '90%' : '1200px',
                    maxHeight: '90vh',
                    outline: 'none',
                }}
            >
                <div className="wgc-modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                        <div className="wgc-modal-title" id="view-worker-types-modal-title">
                            Manage Worker Types
                        </div>
                        <div className="wgc-modal-subtitle">
                            Create, manage and view your worker type configurations
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        {onCreateWorkerType && (
                            <button
                                onClick={onCreateWorkerType}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '10px 16px',
                                    background: '#2c68bd',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    whiteSpace: 'nowrap'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = '#1e4d8c';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = '#2c68bd';
                                }}
                            >
                                <Plus size={16} />
                                Create Worker Type
                            </button>
                        )}
                        <button className="wgc-modal-close" onClick={onClose}>
                            <CloseRoundedIcon />
                        </button>
                    </div>
                </div>

                <div className="wgc-modal-body">
                    <CrudMyWorkerTypes isMobile={isMobile} agencyData={agencyData} />
                </div>
            </div>
        </Modal>
    );
};

const resolveOnboardingDocumentSubTypeLabel = (
    documentSubTypeUniqueIdentifier: string | null | undefined,
    documentSubTypes: readonly TrustVaultDocumentSubTypeRespDTO[]
): string | null => {
    if (!isValidString(documentSubTypeUniqueIdentifier)) {
        return null;
    }
    const resolvedDocumentSubTypeUniqueIdentifier: string =
        (documentSubTypeUniqueIdentifier as string).trim();
    const matchingSubType: TrustVaultDocumentSubTypeRespDTO | undefined = documentSubTypes.find(
        (documentSubType: TrustVaultDocumentSubTypeRespDTO) =>
            documentSubType.subTypeUniqueIdentifier === resolvedDocumentSubTypeUniqueIdentifier
    );
    if (matchingSubType) {
        return matchingSubType.subTypeLabel;
    }
    return resolvedDocumentSubTypeUniqueIdentifier;
};

const OnboardingTemplateDetailsView = ({
    template,
    onBack,
    isMobile,
}: {
    template: WorkTaskTemplateResponseDTO;
    onBack: () => void;
    isMobile: boolean;
}) => {
    const history = useHistory();
    const [documentSubTypes, setDocumentSubTypes] = useState<readonly TrustVaultDocumentSubTypeRespDTO[]>([]);

    useEffect(() => {
        const loadDocumentSubTypes = async (): Promise<void> => {
            try {
                const response = await ListTrustVaultDocumentSubTypesAgencyUserAPICall();
                if (response?.documentSubTypes && Array.isArray(response.documentSubTypes)) {
                    setDocumentSubTypes(response.documentSubTypes);
                }
            } catch (error) {
                console.error('Error loading worker file types for onboarding template view:', error);
            }
        };

        void loadDocumentSubTypes();
    }, []);

    const handleEditTemplate = (): void => {
        history.push(buildEditJobberOnboardingTemplatePath(template.templateId));
    };

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '24px' }}>
                <button 
                    onClick={onBack}
                    style={{ 
                        background: 'transparent', 
                        border: 'none', 
                        cursor: 'pointer', 
                        padding: '0',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#6b7280',
                        marginBottom: '16px',
                        fontSize: '14px', 
                        fontWeight: 500,
                        transition: 'color 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#1f2937'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
                >
                    <ChevronLeft size={20} style={{ marginRight: '4px' }} />
                    Back
                </button>

                <div style={{
                    display: 'flex',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    flexDirection: isMobile ? 'column' : 'row',
                }}>
                    <div>
                        <h3 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: 700, color: '#1f2937' }}>
                            {template.templateName}
                        </h3>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#6b7280', flexWrap: 'wrap' }}>
                            <span>Created on {formatWorkTaskTemplateCreatedDisplay(template.metaData)}</span>
                            <span>•</span>
                            <span style={{ 
                                background: '#eff6ff', 
                                color: '#2c68bd', 
                                padding: '2px 8px', 
                                borderRadius: '12px', 
                                fontSize: '12px', 
                                fontWeight: 600 
                            }}>
                                {template.sections?.length || 0} Sections
                            </span>
                            {templateRequiresWorkerSignature(template.requiredAttributes) ? (
                                <span style={{
                                    background: '#dbeafe',
                                    color: '#1d4ed8',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                }}>
                                    Worker signature
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={handleEditTemplate}
                        style={{
                            padding: '10px 16px',
                            background: '#2c68bd',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        Edit template
                    </button>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                {template.sections?.map((section, index) => (
                    <div key={index} style={{ 
                        border: '1px solid #e5e7eb', 
                        borderRadius: '12px', 
                        overflow: 'hidden',
                        background: 'white',
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{ 
                            padding: '16px 20px', 
                            background: '#f9fafb', 
                            borderBottom: '1px solid #e5e7eb',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{ 
                                    width: '28px', 
                                    height: '28px', 
                                    borderRadius: '50%', 
                                    background: '#2c68bd', 
                                    color: 'white', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center', 
                                    fontSize: '14px',
                                    fontWeight: 600
                                }}>
                                    {index + 1}
                                </div>
                                <h4 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
                                    {section.sectionTitle}
                                </h4>
                            </div>
                            {section.isDefaultSection && (
                                <span style={{ 
                                    fontSize: '12px', 
                                    padding: '2px 8px', 
                                    background: '#e0f2fe', 
                                    color: '#0284c7', 
                                    borderRadius: '12px', 
                                    fontWeight: 600 
                                }}>
                                    Default
                                </span>
                            )}
                        </div>
                        
                        <div style={{ padding: '0' }}>
                            {section.questions?.map((question: WorkTaskQuestionResponseDTO, qIndex) => {
                                const workerFileTypeLabel: string | null = isFileUploadWorkTaskQuestionType(
                                    question.questionType
                                )
                                    ? resolveOnboardingDocumentSubTypeLabel(
                                        question.documentSubTypeUniqueIdentifier,
                                        documentSubTypes
                                    )
                                    : null;

                                return (
                                <div key={qIndex} style={{ 
                                    padding: '20px', 
                                    borderBottom: qIndex < (section.questions?.length || 0) - 1 ? '1px solid #f3f4f6' : 'none',
                                    display: 'flex',
                                    gap: '16px'
                                }}>
                                    <div style={{ 
                                        minWidth: '24px', 
                                        fontSize: '14px', 
                                        fontWeight: 600, 
                                        color: '#9ca3af',
                                        paddingTop: '2px'
                                    }}>
                                        {qIndex + 1}.
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ marginBottom: '8px', fontSize: '15px', color: '#1f2937', fontWeight: 500 }}>
                                            {question.question}
                                            {question.required && <span style={{ color: '#ef4444', marginLeft: '4px' }} title="Required">*</span>}
                                        </div>
                                        
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                            <div style={{ 
                                                display: 'inline-flex', 
                                                alignItems: 'center',
                                                fontSize: '12px', 
                                                color: '#4b5563', 
                                                background: '#f3f4f6', 
                                                padding: '4px 8px', 
                                                borderRadius: '6px',
                                                fontWeight: 500
                                            }}>
                                                {String(question.questionType).replace(/_/g, ' ')}
                                            </div>

                                            {isValidString(workerFileTypeLabel) && (
                                                <div style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    fontSize: '12px',
                                                    color: '#1d4ed8',
                                                    background: '#dbeafe',
                                                    padding: '4px 8px',
                                                    borderRadius: '6px',
                                                    fontWeight: 600,
                                                }}>
                                                    Worker file type: {workerFileTypeLabel}
                                                </div>
                                            )}

                                            {(question.options) && question.options.length > 0 && (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                    {question.options.map((opt, optIdx) => (
                                                        <span key={optIdx} style={{ 
                                                            fontSize: '12px', 
                                                            border: '1px solid #e5e7eb', 
                                                            padding: '3px 8px', 
                                                            borderRadius: '12px', 
                                                            color: '#6b7280',
                                                            background: 'white'
                                                        }}>
                                                            {opt}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        
                                        {isValidString(question.staticText) && (
                                            <div style={{ marginTop: '8px', fontSize: '13px', color: '#4b5563', whiteSpace: 'pre-wrap' }}>
                                                {question.staticText}
                                            </div>
                                        )}

                                        {question.description && (
                                            <div style={{ marginTop: '8px', fontSize: '13px', color: '#6b7280' }}>
                                                {question.description}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                );
                            })}
                            {(!section.questions || section.questions.length === 0) && (
                                <div style={{ padding: '32px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }}>
                                    No questions in this section
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const CrudOnboardingTemplates = ({ isMobile, onSelectTemplate }: { isMobile: boolean, onSelectTemplate: (template: WorkTaskTemplateResponseDTO) => void }) => {
    const [templates, setTemplates] = useState<WorkTaskTemplateResponseDTO[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [updatingTemplateId, setUpdatingTemplateId] = useState<string | null>(null);
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    const fetchTemplates = async (): Promise<void> => {
        try {
            const data = await GetJobberOnboardingTemplatesAPICall();
            if (data) {
                setTemplates(data);
            } else {
                setTemplates([]);
            }
        } catch (error) {
            console.error('Error fetching templates:', error);
            setTemplates([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        void fetchTemplates();
    }, []);

    const handleSetOrClearDefault = async (
        template: WorkTaskTemplateResponseDTO,
        nextType: JobberOnboardingTemplateType,
        event: React.MouseEvent<HTMLButtonElement>
    ): Promise<void> => {
        event.stopPropagation();

        if (
            nextType === JobberOnboardingTemplateType.PRIMARY
            && !isJobberOnboardingTemplateActivated(template)
        ) {
            enqueueSnackbar('Only activated templates can be set as the default for new workers.', {
                variant: 'warning',
            });
            return;
        }

        setUpdatingTemplateId(template.templateId);
        try {
            const updated: WorkTaskTemplateResponseDTO | null =
                await UpdateJobberOnboardingTemplateTypeAPICall({
                    templateId: template.templateId,
                    jobberOnboardingTemplateType: nextType,
                });

            if (updated == null) {
                enqueueSnackbar(
                    nextType === JobberOnboardingTemplateType.PRIMARY
                        ? 'Failed to set default onboarding form'
                        : 'Failed to clear default onboarding form',
                    { variant: 'error' }
                );
                return;
            }

            enqueueSnackbar(
                nextType === JobberOnboardingTemplateType.PRIMARY
                    ? 'Default onboarding form updated'
                    : 'Default onboarding form cleared',
                { variant: 'success' }
            );
            setIsLoading(true);
            await fetchTemplates();
        } catch (error) {
            console.error('Error updating onboarding template default type:', error);
            enqueueSnackbar(
                nextType === JobberOnboardingTemplateType.PRIMARY
                    ? 'Failed to set default onboarding form'
                    : 'Failed to clear default onboarding form',
                { variant: 'error' }
            );
        } finally {
            setUpdatingTemplateId(null);
        }
    };

    if (isLoading) {
        return (
            <div style={{ padding: '40px', display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size={30} style={{ color: '#2c68bd' }} />
            </div>
        );
    }

    return (
        <div style={{ width: '100%' }}>
            {templates.length > 0 ? (
                <div style={{ 
                    border: '1px solid #e5e7eb', 
                    borderRadius: '12px', 
                    overflow: 'hidden',
                    background: 'white'
                }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                        <thead style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                            <tr>
                                <th style={{ textAlign: 'left', padding: '16px 24px', fontSize: '13px', fontWeight: 600, color: '#6b7280', width: isMobile ? '45%' : '40%' }}>TEMPLATE NAME</th>
                                <th style={{ textAlign: 'left', padding: '16px 24px', fontSize: '13px', fontWeight: 600, color: '#6b7280', width: isMobile ? '20%' : '15%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        TYPE
                                        <ToolTipCommonComponent toolTipText={JOBBER_ONBOARDING_DEFAULT_TEMPLATE_TOOLTIP} />
                                    </div>
                                </th>
                                <th style={{ textAlign: 'left', padding: '16px 24px', fontSize: '13px', fontWeight: 600, color: '#6b7280', width: isMobile ? '15%' : '15%' }}>SECTIONS</th>
                                <th style={{ textAlign: 'left', padding: '16px 24px', fontSize: '13px', fontWeight: 600, color: '#6b7280', width: isMobile ? '20%' : '30%' }}>ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {templates.map((template) => {
                                const isPrimary: boolean = isPrimaryJobberOnboardingTemplate(
                                    template.jobberOnboardingTemplateType
                                );
                                const isRowUpdating: boolean = updatingTemplateId === template.templateId;

                                return (
                                <tr 
                                    key={template.templateId} 
                                    onClick={() => onSelectTemplate(template)}
                                    style={{ 
                                        borderBottom: '1px solid #f3f4f6', 
                                        transition: 'background 0.2s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                >
                                    <td style={{ padding: '16px 24px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{
                                                width: '36px',
                                                height: '36px',
                                                borderRadius: '8px',
                                                background: '#f3f4f6',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0
                                            }}>
                                                <FileText size={18} color="#4c4c4c" />
                                            </div>
                                            <div style={{ minWidth: 0 }}>
                                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#1f2937', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {template.templateName}
                                                </div>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                                                    {isPrimary ? (
                                                        <span style={{
                                                            display: 'inline-block',
                                                            padding: '2px 8px',
                                                            borderRadius: 999,
                                                            fontSize: 11,
                                                            fontWeight: 600,
                                                            background: '#dcfce7',
                                                            color: '#166534',
                                                        }}>
                                                            Default for new workers
                                                        </span>
                                                    ) : null}
                                                    {templateRequiresWorkerSignature(template.requiredAttributes) ? (
                                                        <span style={{
                                                            display: 'inline-block',
                                                            padding: '2px 8px',
                                                            borderRadius: 999,
                                                            fontSize: 11,
                                                            fontWeight: 600,
                                                            background: '#dbeafe',
                                                            color: '#1d4ed8',
                                                        }}>
                                                            Worker signature
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ padding: '16px 24px', fontSize: '14px', color: '#374151', fontWeight: 500 }}>
                                        {getJobberOnboardingTemplateTypeLabel(
                                            template.jobberOnboardingTemplateType
                                        )}
                                    </td>
                                    <td style={{ padding: '16px 24px' }}>
                                        <div style={{ 
                                            display: 'inline-flex', 
                                            padding: '4px 10px', 
                                            borderRadius: '12px', 
                                            background: '#eff6ff', 
                                            color: '#2c68bd', 
                                            fontSize: '12px', 
                                            fontWeight: 600 
                                        }}>
                                            {template.sections?.length || 0} Sections
                                        </div>
                                    </td>
                                    <td style={{ padding: '16px 24px' }}>
                                        {isPrimary ? (
                                            <button
                                                type="button"
                                                disabled={isRowUpdating}
                                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                                    void handleSetOrClearDefault(
                                                        template,
                                                        JobberOnboardingTemplateType.SECONDARY,
                                                        event
                                                    );
                                                }}
                                                style={{
                                                    padding: '6px 12px',
                                                    background: 'white',
                                                    color: '#374151',
                                                    border: '1px solid #d1d5db',
                                                    borderRadius: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    cursor: isRowUpdating ? 'not-allowed' : 'pointer',
                                                    opacity: isRowUpdating ? 0.6 : 1,
                                                }}
                                            >
                                                {isRowUpdating ? 'Updating…' : 'Clear default'}
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                disabled={isRowUpdating}
                                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                                    void handleSetOrClearDefault(
                                                        template,
                                                        JobberOnboardingTemplateType.PRIMARY,
                                                        event
                                                    );
                                                }}
                                                style={{
                                                    padding: '6px 12px',
                                                    background: '#2c68bd',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    cursor: isRowUpdating ? 'not-allowed' : 'pointer',
                                                    opacity: isRowUpdating ? 0.6 : 1,
                                                }}
                                            >
                                                {isRowUpdating ? 'Updating…' : 'Set as default'}
                                            </button>
                                        )}
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div style={{
                    padding: '40px 20px',
                    textAlign: 'center',
                    color: '#6b7280',
                    background: '#f9fafb',
                    borderRadius: '12px',
                    border: '1px dashed #d1d5db'
                }}>
                    <FileText size={48} style={{ color: '#d1d5db', marginBottom: '12px' }} />
                    <div style={{ fontSize: '16px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
                        No templates found
                    </div>
                    <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
                        Create your first onboarding template to get started
                    </div>
                    <button
                        onClick={() => history.push(CREATE_WORKER_ONBOARDING_TEMPLATE_PATH)}
                        style={{
                            padding: '8px 16px',
                            background: '#2c68bd',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: 600,
                            cursor: 'pointer'
                        }}
                    >
                        Create Template
                    </button>
                </div>
            )}
        </div>
    );
};

const CrudOnboardingChecklists = ({
  isMobile,
  onCreateChecklist,
  onSelectChecklist,
}: {
  readonly isMobile: boolean;
  readonly onCreateChecklist: () => void;
  readonly onSelectChecklist: (checklistTemplateId: string) => void;
}): React.ReactElement => {
  const [checklists, setChecklists] = useState<readonly WorkerOnboardingChecklistTemplateResponseDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchChecklists = async (): Promise<void> => {
      try {
        const data: readonly WorkerOnboardingChecklistTemplateResponseDTO[] | null =
          await ListWorkerOnboardingChecklistTemplatesAPICall();
        setChecklists(data ?? []);
      } catch (error) {
        console.error('Error fetching onboarding checklists:', error);
        setChecklists([]);
      } finally {
        setIsLoading(false);
      }
    };
    void fetchChecklists();
  }, []);

  if (isLoading) {
    return (
      <div style={{ padding: '40px', display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={30} style={{ color: '#2c68bd' }} />
      </div>
    );
  }

  if (checklists.length === 0) {
    return (
      <div style={{
        padding: '40px 20px',
        textAlign: 'center',
        color: '#6b7280',
        background: '#f9fafb',
        borderRadius: '12px',
        border: '1px dashed #d1d5db',
      }}>
        <ClipboardCheck size={48} style={{ color: '#d1d5db', marginBottom: '12px' }} />
        <div style={{ fontSize: '16px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
          No checklists found
        </div>
        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
          Create your first onboarding checklist to track worker readiness
        </div>
        <button
          type="button"
          onClick={onCreateChecklist}
          style={{
            padding: '8px 16px',
            background: '#2c68bd',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Create Checklist
        </button>
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <div style={{
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        overflow: 'hidden',
        background: 'white',
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <thead style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
            <tr>
              <th style={{
                textAlign: 'left',
                padding: isMobile ? '12px 16px' : '16px 24px',
                fontSize: '13px',
                fontWeight: 600,
                color: '#6b7280',
                width: '45%',
              }}>
                CHECKLIST NAME
              </th>
              <th style={{
                textAlign: 'left',
                padding: isMobile ? '12px 16px' : '16px 24px',
                fontSize: '13px',
                fontWeight: 600,
                color: '#6b7280',
                width: '20%',
              }}>
                STATUS
              </th>
              <th style={{
                textAlign: 'left',
                padding: isMobile ? '12px 16px' : '16px 24px',
                fontSize: '13px',
                fontWeight: 600,
                color: '#6b7280',
                width: '20%',
              }}>
                TYPE
              </th>
              <th style={{
                textAlign: 'left',
                padding: isMobile ? '12px 16px' : '16px 24px',
                fontSize: '13px',
                fontWeight: 600,
                color: '#6b7280',
                width: '15%',
              }}>
                STEPS
              </th>
            </tr>
          </thead>
          <tbody>
            {checklists.map((checklist: WorkerOnboardingChecklistTemplateResponseDTO) => (
              <tr
                key={checklist.checklistTemplateId}
                onClick={() => onSelectChecklist(checklist.checklistTemplateId)}
                style={{
                  borderBottom: '1px solid #f3f4f6',
                  transition: 'background 0.2s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(event: React.MouseEvent<HTMLTableRowElement>): void => {
                  event.currentTarget.style.background = '#f9fafb';
                }}
                onMouseLeave={(event: React.MouseEvent<HTMLTableRowElement>): void => {
                  event.currentTarget.style.background = 'white';
                }}
              >
                <td style={{ padding: isMobile ? '12px 16px' : '16px 24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '8px',
                      background: '#f3f4f6',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}>
                      <ClipboardCheck size={18} color="#4c4c4c" />
                    </div>
                    <div style={{
                      fontSize: '14px',
                      fontWeight: 600,
                      color: '#1f2937',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}>
                      {checklist.checklistName}
                    </div>
                  </div>
                </td>
                <td style={{
                  padding: isMobile ? '12px 16px' : '16px 24px',
                  fontSize: '14px',
                  color: '#6b7280',
                }}>
                  {getChecklistTemplateStatusLabel(checklist.templateStatus)}
                </td>
                <td style={{
                  padding: isMobile ? '12px 16px' : '16px 24px',
                  fontSize: '14px',
                  color: '#6b7280',
                }}>
                  {getChecklistTemplateTypeLabel(checklist.checklistTemplateType)}
                </td>
                <td style={{ padding: isMobile ? '12px 16px' : '16px 24px' }}>
                  <div style={{
                    display: 'inline-flex',
                    padding: '4px 10px',
                    borderRadius: '12px',
                    background: '#eff6ff',
                    color: '#2c68bd',
                    fontSize: '12px',
                    fontWeight: 600,
                  }}>
                    {checklist.steps?.length ?? 0} Steps
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

enum OnboardingModalSection {
  TEMPLATES = 'TEMPLATES',
  CHECKLISTS = 'CHECKLISTS',
}

const ViewOnboardingTemplatesModal = ({ isOpen, onClose, isMobile }: { isOpen: boolean, onClose: () => void, isMobile: boolean }) => {
    const [selectedTemplate, setSelectedTemplate] = useState<WorkTaskTemplateResponseDTO | null>(null);
    const [activeSection, setActiveSection] = useState<OnboardingModalSection>(
      OnboardingModalSection.TEMPLATES
    );
    const history = useHistory();

    useEffect(() => {
        if (!isOpen) {
            setSelectedTemplate(null);
            setActiveSection(OnboardingModalSection.TEMPLATES);
        }
    }, [isOpen]);

    const handleCreateTemplate = (): void => {
        onClose();
        history.push(CREATE_WORKER_ONBOARDING_TEMPLATE_PATH);
    };

    const handleCreateChecklist = (): void => {
        onClose();
        history.push(WORKER_ONBOARDING_CHECKLIST_TEMPLATES_PATH);
    };

    const handleSelectChecklist = (checklistTemplateId: string): void => {
        onClose();
        history.push(buildEditWorkerOnboardingChecklistTemplatePath(checklistTemplateId));
    };

    const primaryActionLabel: string =
      activeSection === OnboardingModalSection.CHECKLISTS
        ? 'Create Checklist'
        : 'Create Template';

    const handlePrimaryAction = (): void => {
      if (activeSection === OnboardingModalSection.CHECKLISTS) {
        handleCreateChecklist();
        return;
      }
      handleCreateTemplate();
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    backdropFilter: 'blur(4px)'
                }
            }}
        >
                <div
                    className="wgc-modal2"
                    style={{
                        width: isMobile ? '90%' : '70%',
                        maxHeight: '90vh',
                        outline: 'none',
                    }}
                >
                    <div className="wgc-modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div>
                            <div style={{
                                margin: 0,
                                fontSize: isMobile ? '20px' : '24px',
                                fontWeight: 700,
                                color: '#1f2937',
                                letterSpacing: '-0.02em',
                                textAlign: 'left',
                            }}>
                                Worker Onboarding
                            </div>
                            <p style={{
                                margin: '4px 0 0 0',
                                fontSize: '14px',
                                color: '#6b7280',
                                fontWeight: 400
                            }}>
                                Manage onboarding form templates and readiness checklists
                            </p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            {!selectedTemplate && (
                                <button
                                    type="button"
                                    onClick={handlePrimaryAction}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '10px 16px',
                                        background: '#2c68bd',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#1e4d8c';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = '#2c68bd';
                                    }}
                                >
                                    <Plus size={16} />
                                    {primaryActionLabel}
                                </button>
                            )}
                            <button
                                type="button"
                                onClick={onClose}
                                className={isMobile ? 'timeclock-close-mobile' : ''}
                                style={isMobile ? { position: 'absolute', top: '20px', right: '20px' } : {
                                    border: 'none',
                                    borderRadius: '8px',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: '#6b7280'
                                }}
                            >
                                {isMobile ? null : <CloseRoundedIcon />}
                            </button>
                        </div>
                    </div>

                    <div style={{
                        padding: isMobile ? '20px' : '24px 32px 32px 32px',
                        overflowY: 'auto',
                        flex: 1
                    }}>
                        {selectedTemplate ? (
                            <OnboardingTemplateDetailsView 
                                template={selectedTemplate} 
                                onBack={() => setSelectedTemplate(null)} 
                                isMobile={isMobile} 
                            />
                        ) : (
                            <>
                              <div
                                style={{
                                  display: 'flex',
                                  gap: 8,
                                  marginBottom: 20,
                                  borderBottom: '1px solid #e5e7eb',
                                  paddingBottom: 0,
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() => setActiveSection(OnboardingModalSection.TEMPLATES)}
                                  style={{
                                    border: 'none',
                                    background: 'transparent',
                                    padding: '10px 14px',
                                    fontSize: 14,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    color:
                                      activeSection === OnboardingModalSection.TEMPLATES
                                        ? '#2c68bd'
                                        : '#6b7280',
                                    borderBottom:
                                      activeSection === OnboardingModalSection.TEMPLATES
                                        ? '2px solid #2c68bd'
                                        : '2px solid transparent',
                                    marginBottom: -1,
                                  }}
                                >
                                  Onboarding Templates
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setActiveSection(OnboardingModalSection.CHECKLISTS)}
                                  style={{
                                    border: 'none',
                                    background: 'transparent',
                                    padding: '10px 14px',
                                    fontSize: 14,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    color:
                                      activeSection === OnboardingModalSection.CHECKLISTS
                                        ? '#2c68bd'
                                        : '#6b7280',
                                    borderBottom:
                                      activeSection === OnboardingModalSection.CHECKLISTS
                                        ? '2px solid #2c68bd'
                                        : '2px solid transparent',
                                    marginBottom: -1,
                                  }}
                                >
                                  Onboarding Checklist
                                </button>
                              </div>

                              {activeSection === OnboardingModalSection.TEMPLATES ? (
                                <CrudOnboardingTemplates
                                  isMobile={isMobile}
                                  onSelectTemplate={setSelectedTemplate}
                                />
                              ) : (
                                <CrudOnboardingChecklists
                                  isMobile={isMobile}
                                  onCreateChecklist={handleCreateChecklist}
                                  onSelectChecklist={handleSelectChecklist}
                                />
                              )}
                            </>
                        )}
                    </div>
                </div>
        </Modal>
    );
};

const ViewShiftConfigModal = ({ open, onClose, shiftAssignmentConfigRules }: { open: boolean, onClose: () => void, shiftAssignmentConfigRules?: ShiftAssignmentConfigRules }) => {
    const isMobile = useIsMobile();
    const { enqueueSnackbar } = useSnackbar();
    const [isAddingRule, setIsAddingRule] = useState(false);
    const [newRuleType, setNewRuleType] = useState<ShiftAssignmentConfigRuleType>(ShiftAssignmentConfigRuleType.REQUESTER_REVIEW_REQUIRED);
    const [isDefaultRule, setIsDefaultRule] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleCreateRule = async () => {
        setIsLoading(true);
        const payload: CreateShiftAssignmentConfigRuleDetail = {
            shiftAssignmentConfigRuleType: newRuleType,
            shiftAssignmentConfigRuleApplicationType: isDefaultRule ? ShiftAssignmentConfigRuleApplicationType.DEFAULT : undefined
        };

        try {
            const response = await CreateShiftAssignmentConfigRuleAPICall(payload);

            if (response) {
                enqueueSnackbar('Rule created successfully', { variant: 'success' });
                setIsAddingRule(false);
                window.location.reload(); 
            } else {
                 enqueueSnackbar('Failed to create rule', { variant: 'error' });
            }
        } catch (error) {
            console.error('Error creating rule:', error);
            enqueueSnackbar('Failed to create rule', { variant: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="shift-config-modal-title"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                className="wgc-modal"
                style={{
                    width: isMobile ? '90%' : '600px',
                    maxHeight: '90vh',
                    outline: 'none',
                }}
            >
                <div className="wgc-modal-header2">
                    <h2 className="wgc-modal-title" id="shift-config-modal-title">
                        Shift Assignment Config Rules
                    </h2>
                    <button className="wgc-modal-close" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <div className="wgc-modal-body">
                    {isAddingRule ? (
                        <div className="wgc-deduction-card">
                            <div className="wgc-section-title">Add New Rule</div>
                            <div className="wgc-form-group">
                                <label className="wgc-label">Rule Type</label>
                                <select
                                    className="wgc-select"
                                    value={newRuleType}
                                    onChange={(e) => setNewRuleType(e.target.value as ShiftAssignmentConfigRuleType)}
                                >
                                    <option value={ShiftAssignmentConfigRuleType.REQUESTER_REVIEW_REQUIRED}>Requester Review Required</option>
                                </select>
                            </div>
                            <div className="wgc-form-group" style={{ marginTop: '0.75rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        checked={isDefaultRule}
                                        onChange={(e) => setIsDefaultRule(e.target.checked)}
                                        style={{ width: '16px', height: '16px' }}
                                    />
                                    <span className="wgc-label" style={{ margin: 0 }}>Default Rule (Applies to every shift)</span>
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                                <button className="wgc-action-btn" onClick={() => setIsAddingRule(false)}>
                                    Cancel
                                </button>
                                <button className="wgc-action-btn primary" onClick={handleCreateRule} disabled={isLoading}>
                                    {isLoading ? 'Creating...' : 'Create Rule'}
                                </button>
                            </div>
                        </div>
                    ) : (
                        <button className="wgc-action-btn primary" onClick={() => setIsAddingRule(true)}>
                            <Plus size={16} /> Add new Shift Rule Config
                        </button>
                    )}

                    {shiftAssignmentConfigRules ? (
                        <>
                            {shiftAssignmentConfigRules.defaultShiftAssignmentConfigRuleDetail && (
                                <div style={{ marginTop: '1.5rem' }}>
                                    <div className="wgc-section-title">Default Rule</div>
                                    <div className="wgc-config-card">
                                        <div className="wgc-config-row">
                                            <div className="wgc-config-label">Type:</div>
                                            <div className="wgc-config-value">{shiftAssignmentConfigRules.defaultShiftAssignmentConfigRuleDetail.shiftAssignmentConfigRuleType}</div>
                                        </div>
                                        <div className="wgc-config-row">
                                            <div className="wgc-config-label">Application Type:</div>
                                            <div className="wgc-config-value">{shiftAssignmentConfigRules.defaultShiftAssignmentConfigRuleDetail.shiftAssignmentConfigRuleApplicationType}</div>
                                        </div>
                                        <div className="wgc-config-row">
                                            <div className="wgc-config-label">Created:</div>
                                            <div className="wgc-config-value">{new Date(shiftAssignmentConfigRules.defaultShiftAssignmentConfigRuleDetail.creationDateTimeEpochSec * 1000).toLocaleString()}</div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {shiftAssignmentConfigRules.shiftConfigDetails && shiftAssignmentConfigRules.shiftConfigDetails.length > 0 && (
                                <div style={{ marginTop: '1.5rem' }}>
                                    <div className="wgc-section-title">Config Details</div>
                                    {shiftAssignmentConfigRules.shiftConfigDetails.map((rule, index) => (
                                        rule?.ruleId === shiftAssignmentConfigRules?.defaultShiftAssignmentConfigRuleDetail?.ruleId
                                        ? null
                                        : (
                                            <div key={rule.ruleId || index} className="wgc-config-card" style={{ marginBottom: '0.75rem' }}>
                                                <div className="wgc-config-row">
                                                    <div className="wgc-config-label">Type:</div>
                                                    <div className="wgc-config-value">{rule.shiftAssignmentConfigRuleType}</div>
                                                </div>
                                                <div className="wgc-config-row">
                                                    <div className="wgc-config-label">Application Type:</div>
                                                    <div className="wgc-config-value">{rule.shiftAssignmentConfigRuleApplicationType}</div>
                                                </div>
                                                <div className="wgc-config-row">
                                                    <div className="wgc-config-label">Created:</div>
                                                    <div className="wgc-config-value">{new Date(rule.creationDateTimeEpochSec * 1000).toLocaleString()}</div>
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </div>
                            )}
                            
                            {!shiftAssignmentConfigRules.defaultShiftAssignmentConfigRuleDetail && (!shiftAssignmentConfigRules.shiftConfigDetails || shiftAssignmentConfigRules.shiftConfigDetails.length === 0) && (
                                <div className="wgc-empty-state">
                                    No configuration rules found.
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="wgc-empty-state">
                            No configuration rules found.
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

const BulkActionMenu = ({ selectedEmails, onChangeStatus }: { selectedEmails: string[], onChangeStatus: () => void }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id="bulk-actions-button"
                aria-controls={open ? 'bulk-actions-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                disabled={selectedEmails.length === 0}
                variant="outlined"
                endIcon={<ChevronDown size={16}/>}
                style={{
                     height: '50px', 
                     borderRadius: '15px', 
                     borderColor: '#e5e7eb', 
                     color: '#374151',
                     textTransform: 'none',
                     backgroundColor: 'white',
                     marginLeft: '10px',
                     minWidth: '130px'
                }}
            >
                Bulk Actions {selectedEmails.length > 0 && `(${selectedEmails.length})`}
            </Button>
            <Menu
                id="bulk-actions-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'bulk-actions-button',
                }}
            >
                <MenuItem onClick={() => { handleClose(); onChangeStatus(); }}>Change Status</MenuItem>
            </Menu>
        </div>
    );
};

const PageHeader = ({isMobile, gridViewActive, setGridViewActive}:{isMobile:boolean, gridViewActive:boolean, setGridViewActive: (active: boolean) => void}) => {
    return (
        <div className={isMobile ? 'payments-header-holder-mobile' : 'payments-header-holder'}>
            <div className='payments-header'>
                <div className='payments-header-title-holder'>
                    <div style={{marginLeft: "5px", marginTop: "5px", cursor: "auto"}} id="payments-header-active" className={isMobile ? 'payments-header-title-switch-mobile':'payments-header-title-switch'}>
                        Workforce Management
                    </div>
                </div>
                <div className='payments-header-subtitle'>Manage and View your Workers</div>
            </div>
            
            <div className='header-selection-toggle'>
                <Tooltip title="Grid View" placement='bottom' arrow>
                    <button 
                        id={gridViewActive ? 'header-selection-toggle-btn-active' : ''} 
                        className='header-selection-toggle-btn'
                        onClick={() => setGridViewActive(true)}>
                        <ViewModuleRoundedIcon />
                    </button>
                </Tooltip>
                <Tooltip title="List View" placement='bottom' arrow>
                    <button 
                        id={!gridViewActive ? 'header-selection-toggle-btn-active' : ''} 
                        className='header-selection-toggle-btn'
                        onClick={() => setGridViewActive(false)}>
                        <ViewListRoundedIcon />
                    </button>
                </Tooltip>
            </div>
        </div>
    );
};

const JobberWorkforceGridBuilder = ({firstName, lastName, rating, email, phoneNumber, icon, availability, city, isMobile, jobberStatus, onHire, jobber, availableWorkerTypes, onJobberUpdated, agencyData, isSelected, onToggleSelection, onContractorDetailsCreated}:{
    firstName:string, 
    lastName:string, 
    rating:number, 
    email:string, 
    phoneNumber:string, 
    icon:string, 
    availability:string, 
    city:string, 
    isMobile:boolean,
    jobberStatus?: JobberStatus,
    onHire: () => void,
    jobber: JobberFullProfileDetails,
    availableWorkerTypes: JobberWorkerTypeAgencyPrivateViewDTO[],
    onJobberUpdated?: (updatedJobber: JobberFullProfileDetails) => void,
    agencyData?: AgencyObjClient | null,
    isSelected: boolean,
    onToggleSelection: () => void,
    onContractorDetailsCreated?: (jobberEmail: string) => void | Promise<void>
})=>{
    const history = useHistory();
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [isResendingEmail, setIsResendingEmail] = useState(false);
    const [currentJobber, setCurrentJobber] = useState<JobberFullProfileDetails>(jobber);
    const { enqueueSnackbar } = useSnackbar();

    const openJobberDetailsPage = (event: React.MouseEvent): void => {
        const jobberDetailsUrl: string = buildAgencyJobberDetailsUrl(email);
        if (event.metaKey || event.ctrlKey) {
            window.open(jobberDetailsUrl, '_blank', 'noopener,noreferrer');
            return;
        }
        history.push(jobberDetailsUrl);
    };

    useEffect(() => {
        setCurrentJobber(jobber);
    }, [jobber]);
    
    const handleJobberUpdated = (updatedJobber: JobberFullProfileDetails) => {
        setCurrentJobber(updatedJobber);
        if (onJobberUpdated) {
            onJobberUpdated(updatedJobber);
        }
    };

    const handleStatusChanged = () => {
         window.location.reload();
    };

    const handleResendRegistrationEmail = async (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsResendingEmail(true);
        try {
            const request: ResendJobberRegistrationEmailRequestDTO = {
                jobberEmail: currentJobber.jobberDetails.userDetails.userEmail
            };
            const response = await ResendJobberRegistrationEmailAPICall(request);
            if (response) {
                enqueueSnackbar('Registration email resent successfully!', { variant: 'success' });
            } else {
                enqueueSnackbar('Failed to resend registration email. Please try again.', { variant: 'error' });
            }
        } catch (error) {
            console.error('Error resending registration email:', error);
            enqueueSnackbar('An error occurred while resending the registration email.', { variant: 'error' });
        } finally {
            setIsResendingEmail(false);
        }
    };
    
    return(
        <>
        {isMobile?(
            <div className='jobber-workforce-card-mobile' onClick={openJobberDetailsPage} style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 10 }}>
                     <Checkbox 
                        checked={isSelected}
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggleSelection();
                        }}
                        sx={{
                            color: '#d1d5db',
                            '&.Mui-checked': {
                                color: '#2c68bd',
                            },
                        }}
                     />
                </div>
                
                <div className='jobber-workforce-card-icon-holder-mobile'>
                    <div className='jobber-workforce-card-icon-mobile'><img src={icon}/></div>
                    <div className='jobber-workforce-card-rating-mobile'><Rating readOnly defaultValue={rating} style={{ fontSize: '13px'}}/></div>
                </div>

                <div className='jobber-workforce-card-details-holder-mobile'>
                    <div className='jobber-workforce-card-detail-top-holder-mobile'>

                        <div className='jobber-workforce-card-name-mobile'>{firstName + " " + lastName}</div>
                        <div style={{fontSize: '12px', color: '#6b7280', marginBottom: '4px'}}>
                            {getJobberStatusMessageForReadOnlySingleWorker(jobberStatus)}
                        </div>
                        <div className='jobber-workforce-card-availability-mobile'>
                            {availability !== "Unavailable" ? <div className='jobber-workforce-card-availability'><WorkforceTagBuilder isMobile={isMobile} timeString={availability} /></div>:null}
                        </div>

                    </div>

                    <div className='jobber-workforce-card-detail-holder-mobile'>

                        {city?<div className='jobber-workforce-card-detail-mobile'>
                            <div className='jobber-workforce-card-detail-title-mobile'><PlaceRoundedIcon style={{fontSize:"17px"}}/></div>                                
                        </div>:null}

                        <div className='jobber-workforce-card-detail-mobile'>
                            <div className='jobber-workforce-card-detail-title-mobile'><AlternateEmailRoundedIcon style={{fontSize:"17px"}}/></div>
                            <div onClick={() => copyToClipboard(email)} className='jobber-workforce-card-detail-value-mobile'>{email}</div>
                        </div>
                        
                        <div className='jobber-workforce-card-detail-mobile'>
                            <div className='jobber-workforce-card-detail-title-mobile'><LocalPhoneRoundedIcon style={{fontSize:"17px"}}/></div>
                            <div onClick={() => copyToClipboard(phoneNumber)} className='jobber-workforce-card-detail-value-mobile'>{phoneNumber}</div>
                        </div>

                        <div className='jobber-workforce-card-detail-mobile'>
                            <button onClick={(e) => { e.stopPropagation(); setIsStatusModalOpen(true); }} className='workforce-hire-now-btn-mobile'>
                                Change Status
                            </button>
                        </div>

                        {jobberStatus === JobberStatus.REGISTERED_BY_ORG_AGENCY_NEEDS_TO_ON_BOARD && (
                            <div className='jobber-workforce-card-detail-mobile'>
                                <button 
                                    onClick={handleResendRegistrationEmail} 
                                    disabled={isResendingEmail}
                                    className='workforce-hire-now-btn-mobile'
                                    style={{ background: '#2c68bd', color: 'white', border: '1px solid #2c68bd' }}
                                >
                                    {isResendingEmail ? <CircularProgress size={14} color="inherit" /> : 'Re-send Invite'}
                                </button>
                            </div>
                        )}

                    </div>
                    
                </div>
            </div>
        )
        :
        (<div className='jobber-workforce-card-v2' onClick={openJobberDetailsPage}>
            {/* Checkbox - top right */}
            <div className='jobber-workforce-card-v2-checkbox'>
                 <Checkbox 
                    checked={isSelected}
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleSelection();
                    }}
                    sx={{
                        color: '#d1d5db',
                        '&.Mui-checked': {
                            color: '#2c68bd',
                        },
                        padding: 0,
                        '& .MuiSvgIcon-root': {
                            fontSize: 28,
                            borderRadius: '6px',
                        }
                    }}
                 />
            </div>

            {/* Header - Image + Name + Status */}
            <div className='jobber-workforce-card-v2-header'>
                <div className='jobber-workforce-card-v2-avatar'>
                    <img src={icon} alt={firstName + " " + lastName}/>
                </div>
                <div className='jobber-workforce-card-v2-header-info'>
                    <div className='jobber-workforce-card-v2-name'>
                        {firstName === 'NOT_PROVIDED' && lastName === 'NOT_PROVIDED'
                            ? 'Not Provided'
                            : firstName === 'NOT_PROVIDED'
                                ? lastName
                                : lastName === 'NOT_PROVIDED'
                                    ? firstName
                                    : `${firstName} ${lastName}`
                        }
                    </div>
                    <div className='jobber-workforce-card-v2-status'>
                        {getJobberStatusMessageForReadOnlySingleWorker(jobberStatus)}
                    </div>
                </div>
            </div>

            {/* Contact Details */}
            <div className='jobber-workforce-card-v2-contact'>
                <div className='jobber-workforce-card-v2-contact-row'>
                    <span className='jobber-workforce-card-v2-label'>Email:</span>
                    <Tooltip sx={{ fontFamily: 'DM Sans' }} title="Click to Copy" placement='right' arrow>
                        <span onClick={(e) => { e.stopPropagation(); copyToClipboard(email); }} className='jobber-workforce-card-v2-value'>{email}</span>
                    </Tooltip>
                </div>
                <div className='jobber-workforce-card-v2-contact-row'>
                    <span className='jobber-workforce-card-v2-label'>Phone:</span>
                    <Tooltip title="Click to Copy" placement='right' arrow>
                        <span onClick={(e) => { e.stopPropagation(); copyToClipboard(phoneNumber); }} className='jobber-workforce-card-v2-value'>{phoneNumber || 'Not provided'}</span>
                    </Tooltip>
                </div>
            </div>

            {/* Availability & Rating Row */}
            <div className='jobber-workforce-card-v2-stats'>
                    {availability !== "Unavailable" ? (
                <div className='jobber-workforce-card-v2-stat-item'>
                    <span className='jobber-workforce-card-v2-stat-label'>Availability</span>
                        <div className='jobber-workforce-card-v2-availability-pills'>
                            <WorkforceTagBuilder isMobile={isMobile} timeString={availability} />
                        </div>
                </div>
                    ) : (null)}
                <div className='jobber-workforce-card-v2-stat-item'>
                    <span className='jobber-workforce-card-v2-stat-label'>Rating</span>
                    <div className='jobber-workforce-card-v2-rating'>
                        <span className='jobber-workforce-card-v2-rating-star'>★</span>
                        <span className='jobber-workforce-card-v2-rating-value'>{rating.toFixed(2)}</span>
                    </div>
                </div>
            </div>

            {/* Change Status Button */}
            <div className='jobber-workforce-card-v2-actions'>
                <Tooltip title="Click to Change Status" placement='bottom' arrow>
                    <button 
                        className='jobber-workforce-card-v2-btn'
                        onClick={(e) => { e.stopPropagation(); setIsStatusModalOpen(true); }}>
                        Change Status
                    </button>        
                </Tooltip>
                
                {jobberStatus === JobberStatus.REGISTERED_BY_ORG_AGENCY_NEEDS_TO_ON_BOARD && (
                    <Tooltip title="Re-send Invite" placement='bottom' arrow>
                        <button 
                            className='jobber-workforce-card-v2-btn jobber-workforce-card-v2-btn-secondary'
                            onClick={handleResendRegistrationEmail}
                            disabled={isResendingEmail}
                        >
                            {isResendingEmail ? <CircularProgress size={14} color="inherit" /> : 'Re-send Invite'}
                        </button>        
                    </Tooltip>
                )}
            </div>
        </div>)}
        <ChangeJobberStatusModal
            isOpen={isStatusModalOpen}
            onClose={() => setIsStatusModalOpen(false)}
            jobberEmails={[email]}
            currentStatus={jobberStatus}
            onStatusChanged={handleStatusChanged}
        />
    </>
    )
}

const GridViewV2 = ({ isMobile, jobberData, availableWorkerTypes, setJobberData, agencyData, selectedJobberEmails, handleToggleSelection, setIsViewWorkerTypesModalOpen, setIsManageWorkerFileTypesModalOpen, setIsViewTemplatesModalOpen, setIsViewShiftConfigModalOpen, setIsBulkStatusModalOpen }: { isMobile: boolean, jobberData: JobberFullProfileDetails[], availableWorkerTypes: JobberWorkerTypeAgencyPrivateViewDTO[], setJobberData: (data: JobberFullProfileDetails[]) => void, agencyData: AgencyObjClient | null, selectedJobberEmails: string[], handleToggleSelection: (email: string) => void, setIsViewWorkerTypesModalOpen: (open: boolean) => void, setIsManageWorkerFileTypesModalOpen: (open: boolean) => void, setIsViewTemplatesModalOpen: (open: boolean) => void, setIsViewShiftConfigModalOpen: (open: boolean) => void, setIsBulkStatusModalOpen: (open: boolean) => void }) => {
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [statusFilter, setStatusFilter] = useState<string[]>([...DEFAULT_WORKFORCE_STATUS_FILTER]);
    const [workerTypeFilter, setWorkerTypeFilter] = useState<string[]>([]);
    const [attributeMatchingEmails, setAttributeMatchingEmails] = useState<readonly string[] | null>(null);
    const [isHiring, setIsHiring] = useState<boolean>(false);
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    
    const showSuccessMessage = (message: string) => {
        enqueueSnackbar(message, { variant: 'success' });
    };

    const showErrorMessage = (message: string) => {
        enqueueSnackbar(message, { variant: 'error' });
    };

    const jobbers = jobberData;
    
    const handleJobberUpdated = (updatedJobber: JobberFullProfileDetails) => {
        const updatedJobbers = jobberData.map(j => 
            j.jobberDetails.userDetails.userEmail.value === updatedJobber.jobberDetails.userDetails.userEmail.value 
                ? updatedJobber 
                : j
        );
        setJobberData(updatedJobbers);
    };

    const handleContractorDetailsCreated = async (jobberEmail: string): Promise<void> => {
        const data = await GetAllJobberAvailbilities();
        if (data) {
            const updated = data.find((j) => j.jobberDetails.userDetails.userEmail.value === jobberEmail);
            if (updated) {
                handleJobberUpdated(updated);
            }
        }
    };

    const handleHireJobber = async (jobberEmail: string, jobberName: string) => {
        try {
            setIsHiring(true);
            const hireRequest = { jobberEmail: { value: jobberEmail } };
            const result = await FullyHireJobberAPICall(hireRequest);
            if (result) {
                // Refresh the jobber data after successful hire
                const updatedData = await GetAllJobberAvailbilities();
                if (updatedData && Array.isArray(updatedData)) {
                    setJobberData(updatedData);
                    showSuccessMessage(`${jobberName} has been successfully hired!`);
                    
                }
            }
        } catch (error) {
            console.error('Error hiring jobber:', error);
            showErrorMessage('Failed to hire jobber. Please try again.');                
        } finally {
            setIsHiring(false);
        }
    };

    const filterJobbers = (query: string) => {
        if (!query && statusFilter.length === 0 && workerTypeFilter.length === 0 && attributeMatchingEmails === null) return jobbers; // Return all jobbers if query is empty and no status filter

        let filtered = jobbers;

        if (statusFilter.length > 0) {
            filtered = filtered.filter(jobber => 
                statusFilter.includes(jobber.jobberStatus || jobber.jobberDetails.jobberStatus)
            );
        }

        if (workerTypeFilter.length > 0) {
            filtered = filtered.filter(jobber => {
                const jobberTypes = jobber.jobberWorkerTypes || [];
                return jobberTypes.some((type: any) => workerTypeFilter.includes(type.workerTypeName));
            });
        }

        if (attributeMatchingEmails !== null) {
            filtered = filtered.filter((jobber) =>
                attributeMatchingEmails.includes(jobber.jobberDetails.userDetails.userEmail.value)
            );
        }

        if (!query) return filtered;

        const lowerCaseQuery = query.toLowerCase();

        return filtered.filter((jobber) => {
            const { firstName, lastName, userEmail, userPhoneNumber } = jobber.jobberDetails.userDetails;
            const fullName = `${firstName} ${lastName}`.toLowerCase();
            const city = jobber.jobberAvailability?.cities?.join(', ').toLowerCase() || '';
            return (
                fullName.includes(lowerCaseQuery) ||
                userEmail.value.toLowerCase().includes(lowerCaseQuery) ||
                userPhoneNumber.value.includes(lowerCaseQuery) ||
                city.includes(lowerCaseQuery) // Add city search
            );
        });
    };

    const filteredJobbers = filterJobbers(searchQuery);

    return (
        <>
            <div className={isMobile ? 'workforce-search-container-mobile' : 'workforce-top-actions-container'} style={isMobile ? {} : { display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'flex-start' }}>
            {!isMobile && (
                <>
                    <WorkforceHeaderActionButtons
                        isMobile={false}
                        onInviteNewWorker={(): void => {
                            history.push('/agency/add-workers');
                        }}
                        onManageWorkerTypes={(): void => {
                            setIsViewWorkerTypesModalOpen(true);
                        }}
                        onManageWorkerFileTypes={(): void => {
                            setIsManageWorkerFileTypesModalOpen(true);
                        }}
                        onManageAttributes={(): void => {
                            history.push(WORKY_WEB_APP_PATHS.agencyAttributes);
                        }}
                        onWorkforceNotices={(): void => {
                            history.push(WORKY_WEB_APP_PATHS.agencyWorkforceNotices);
                        }}
                        onOnboardingTemplates={(): void => {
                            setIsViewTemplatesModalOpen(true);
                        }}
                        onViewShiftConfigs={(): void => {
                            setIsViewShiftConfigModalOpen(true);
                        }}
                    />

                    <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                        <div className='workforce-search-container' style={{boxShadow: 'none', border: '1px solid #e5e7eb', background: 'white', height: '50px', borderRadius: '15px', flex: 1}}>
                            <Search size={18} style={{ color: '#9ca3af', flexShrink: 0, marginLeft: '10px' }} />
                            <input
                                type="text"
                                placeholder="Search By Worker, Email, Phone Number, City"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="workforce-search-input"
                                style={isMobile ? { width: '100%', minWidth: 'auto', maxWidth: '100%' } : { flex: '1 1 auto', fontSize: '13.5px', color: '#374151', fontWeight: '500' }}
                            />
                        </div>
                        <FormControl size="small" sx={{ minWidth: 200, maxWidth: 300, bgcolor: 'white', borderRadius: '15px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' } }}>
                            <Select
                                multiple
                                displayEmpty
                                value={statusFilter}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setStatusFilter(typeof value === 'string' ? value.split(',') : value);
                                }}
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <span style={{ color: '#9ca3af' }}>Filter by Status</span>;
                                    }
                                    return selected.map(status => getJobberStatusMessageForReadOnly(status)).join(', ');
                                }}
                                sx={{ 
                                    borderRadius: '15px', 
                                    height: '50px', 
                                    fontSize: '13.5px',
                                    '& .MuiSelect-select': {
                                        paddingRight: '32px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 250,
                                            borderRadius: '12px',
                                            marginTop: '8px',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }
                                }}
                            >
                                {FILTERABLE_JOBBER_STATUSES.map((status) => (
                                    <MenuItem key={status} value={status} sx={{ fontSize: '13.5px' }}>
                                        <Checkbox 
                                            checked={statusFilter.indexOf(status) > -1} 
                                            size="small"
                                            sx={{ 
                                                color: '#d1d5db',
                                                '&.Mui-checked': {
                                                    color: '#2c68bd',
                                                },
                                                padding: '4px 8px 4px 0'
                                            }}
                                        />
                                        <ListItemText 
                                            primary={getJobberStatusMessageForReadOnly(status)} 
                                            primaryTypographyProps={{ style: { fontSize: '13.5px', fontWeight: 500 } }} 
                                        />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl size="small" sx={{ minWidth: 200, maxWidth: 300, bgcolor: 'white', borderRadius: '15px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' } }}>
                            <Select
                                multiple
                                displayEmpty
                                value={workerTypeFilter}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setWorkerTypeFilter(typeof value === 'string' ? value.split(',') : value);
                                }}
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <span style={{ color: '#9ca3af' }}>Filter by Worker Type</span>;
                                    }
                                    return selected.join(', ');
                                }}
                                sx={{ 
                                    borderRadius: '15px', 
                                    height: '50px', 
                                    fontSize: '13.5px',
                                    '& .MuiSelect-select': {
                                        paddingRight: '32px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 250,
                                            borderRadius: '12px',
                                            marginTop: '8px',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }
                                }}
                            >
                                {availableWorkerTypes.length === 0 ? (
                                    <MenuItem disabled value="">
                                        <span style={{ color: '#9ca3af' }}>No worker types available</span>
                                    </MenuItem>
                                ) : (
                                    availableWorkerTypes.map((type) => (
                                        <MenuItem key={type.workerTypeUniqueIdentifier} value={type.workerTypeName} sx={{ fontSize: '13.5px' }}>
                                            <Checkbox 
                                                checked={workerTypeFilter.indexOf(type.workerTypeName) > -1} 
                                                size="small"
                                                sx={{ 
                                                    color: '#d1d5db',
                                                    '&.Mui-checked': {
                                                        color: '#2c68bd',
                                                    },
                                                    padding: '4px 8px 4px 0'
                                                }}
                                            />
                                            <ListItemText 
                                                primary={type.workerTypeName} 
                                                primaryTypographyProps={{ style: { fontSize: '13.5px', fontWeight: 500 } }} 
                                            />
                                        </MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                        <WorkforceAttributeSearchFilter
                            isMobile={false}
                            onMatchingWorkerEmailsChange={setAttributeMatchingEmails}
                        />
                        <BulkActionMenu 
                            selectedEmails={selectedJobberEmails} 
                            onChangeStatus={() => setIsBulkStatusModalOpen(true)} 
                        />
                    </div>
                </>
                )}
                {isMobile && (
                    <div className='mobile-search-button-holder'>
                        <div className='mobile-search-holder'>
                        <Search size={20} style={{ color: '#7d7d7d', flexShrink: 0 }} />
                            <input
                                type="text"
                                placeholder="Search By Worker, Email, Phone Number, City"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="workforce-search-input"
                                style={isMobile ? { width: '100%', minWidth: 'auto', maxWidth: '100%' } : { flex: '1 1 auto' }}
                            />
                        </div>
                        <div style={{marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap'}}>
                            <FormControl size="small" sx={{ flex: 1, minWidth: '140px', bgcolor: 'white', borderRadius: '8px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' } }}>
                                <Select
                                    multiple
                                    displayEmpty
                                    value={statusFilter}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        setStatusFilter(typeof value === 'string' ? value.split(',') : value);
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <span style={{ color: '#9ca3af' }}>Status</span>;
                                        }
                                        return selected.map(status => getJobberStatusMessageForReadOnly(status)).join(', ');
                                    }}
                                    sx={{ 
                                        borderRadius: '8px', 
                                        height: '42px', 
                                        fontSize: '14px', 
                                        '& .MuiSelect-select': {
                                            paddingRight: '32px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                                width: 250,
                                                borderRadius: '12px',
                                                marginTop: '8px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                            },
                                        },
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }
                                    }}
                                >
                                    {FILTERABLE_JOBBER_STATUSES.map((status) => (
                                        <MenuItem key={status} value={status} sx={{ fontSize: '13.5px' }}>
                                            <Checkbox 
                                                checked={statusFilter.indexOf(status) > -1} 
                                                size="small"
                                                sx={{ 
                                                    color: '#d1d5db',
                                                    '&.Mui-checked': {
                                                        color: '#2c68bd',
                                                    },
                                                    padding: '4px 8px 4px 0'
                                                }}
                                            />
                                            <ListItemText 
                                                primary={getJobberStatusMessageForReadOnly(status)} 
                                                primaryTypographyProps={{ style: { fontSize: '13.5px', fontWeight: 500 } }} 
                                            />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small" sx={{ flex: 1, minWidth: '140px', bgcolor: 'white', borderRadius: '8px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' } }}>
                                <Select
                                    multiple
                                    displayEmpty
                                    value={workerTypeFilter}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        setWorkerTypeFilter(typeof value === 'string' ? value.split(',') : value);
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <span style={{ color: '#9ca3af' }}>Worker Types</span>;
                                        }
                                        return selected.join(', ');
                                    }}
                                    sx={{ 
                                        borderRadius: '8px', 
                                        height: '42px', 
                                        fontSize: '14px', 
                                        '& .MuiSelect-select': { 
                                            padding: '8px 32px 8px 14px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        } 
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                                width: 250,
                                                borderRadius: '12px',
                                                marginTop: '8px'
                                            },
                                        },
                                    }}
                                >
                                    {availableWorkerTypes.length === 0 ? (
                                        <MenuItem disabled value="">
                                            <span style={{ color: '#9ca3af' }}>No worker types available</span>
                                        </MenuItem>
                                    ) : (
                                        availableWorkerTypes.map((type) => (
                                            <MenuItem key={type.workerTypeUniqueIdentifier} value={type.workerTypeName}>
                                                <Checkbox 
                                                    checked={workerTypeFilter.indexOf(type.workerTypeName) > -1} 
                                                    size="small"
                                                    sx={{ 
                                                        color: '#d1d5db',
                                                        '&.Mui-checked': {
                                                            color: '#2c68bd',
                                                        },
                                                        padding: '4px 8px 4px 0'
                                                    }}
                                                />
                                                <ListItemText 
                                                    primary={type.workerTypeName} 
                                                    primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 500 } }}
                                                />
                                            </MenuItem>
                                        ))
                                    )}
                                </Select>
                            </FormControl>
                            <WorkforceAttributeSearchFilter
                                isMobile={true}
                                onMatchingWorkerEmailsChange={setAttributeMatchingEmails}
                            />
                            <BulkActionMenu 
                                selectedEmails={selectedJobberEmails} 
                                onChangeStatus={() => setIsBulkStatusModalOpen(true)} 
                            />
                        </div>
                        <WorkforceHeaderActionButtons
                            isMobile={true}
                            onInviteNewWorker={(): void => {
                                history.push('/agency/add-workers');
                            }}
                            onManageWorkerTypes={(): void => {
                                setIsViewWorkerTypesModalOpen(true);
                            }}
                            onManageWorkerFileTypes={(): void => {
                                setIsManageWorkerFileTypesModalOpen(true);
                            }}
                            onManageAttributes={(): void => {
                                history.push(WORKY_WEB_APP_PATHS.agencyAttributes);
                            }}
                            onWorkforceNotices={(): void => {
                                history.push(WORKY_WEB_APP_PATHS.agencyWorkforceNotices);
                            }}
                            onOnboardingTemplates={(): void => {
                                setIsViewTemplatesModalOpen(true);
                            }}
                            onViewShiftConfigs={(): void => {
                                setIsViewShiftConfigModalOpen(true);
                            }}
                        />
                    </div>
                )}
                
            </div>

            <div className={isMobile ? 'workforce-container-grid-mobile' : 'workforce-container-grid'}>
                {filteredJobbers.map((jobber, index) => {
                    const userDetails = jobber.jobberDetails.userDetails;
                    const profilePicUrl = jobber.jobberDetails.profilePicUrl;
                    const city = jobber.jobberAvailability?.cities?.join(', ') || '';
                    const availability = jobber.jobberAvailability?.dayIntervals?.join(', ') || 'Unavailable';
                    const jobberName = `${userDetails.firstName} ${userDetails.lastName}`;

                    return (
                        <JobberWorkforceGridBuilder
                            key={index}
                            firstName={userDetails.firstName}
                            lastName={userDetails.lastName}
                            rating={5} 
                            email={userDetails.userEmail.value}
                            phoneNumber={isTestPhoneNumber(userDetails.userPhoneNumber.value) ? 'Not provided' : userDetails.userPhoneNumber.value}
                            icon={profilePicUrl || defaultPic}
                            availability={availability}
                            city={city}
                            isMobile={isMobile}
                            jobberStatus={jobber.jobberStatus}
                            onHire={() => handleHireJobber(userDetails.userEmail.value, jobberName)}
                            jobber={jobber}
                            availableWorkerTypes={availableWorkerTypes}
                            onJobberUpdated={handleJobberUpdated}
                            agencyData={agencyData}
                            isSelected={selectedJobberEmails.includes(userDetails.userEmail.value)}
                            onToggleSelection={() => handleToggleSelection(userDetails.userEmail.value)}
                            onContractorDetailsCreated={handleContractorDetailsCreated}
                        />
                    );
                })}
            </div>
        </>
    );
};

const getWorkforceListRowFirstName = (row: JobberFullProfileDetails): string => {
    return row?.jobberDetails?.userDetails?.firstName ?? '';
};

const getWorkforceListRowLastName = (row: JobberFullProfileDetails): string => {
    return row?.jobberDetails?.userDetails?.lastName ?? '';
};

const getWorkforceListRowEmail = (row: JobberFullProfileDetails): string => {
    return row?.jobberDetails?.userDetails?.userEmail?.value ?? '';
};

const getWorkforceListRowPhone = (row: JobberFullProfileDetails): string => {
    return row?.jobberDetails?.userDetails?.userPhoneNumber?.value ?? '';
};

const getWorkforceListRowStatus = (row: JobberFullProfileDetails): string => {
    const jobberStatus: JobberStatus | string | undefined | null =
        row?.jobberDetails?.jobberStatus ?? row?.jobberStatus;
    return getJobberStatusMessageForReadOnlySingleWorker(jobberStatus);
};

const getWorkforceListRowEmploymentType = (row: JobberFullProfileDetails): string => {
    const firstEmploymentConfig: JobberEmploymentDeductionsConfigDTO | undefined =
        row?.jobberEmploymentDeductionsConfig?.[0];
    const employmentTypeName: string | undefined = firstEmploymentConfig?.corpJobberEmploymentTypeName;
    if (!isValidString(employmentTypeName)) {
        return '';
    }
    return employmentTypeName;
};

const getWorkforceListRowWorkerTypes = (row: JobberFullProfileDetails): JobberWorkerTypeAgencyPrivateViewDTO[] => {
    const assignedWorkerTypes: JobberWorkerTypeAgencyPrivateViewDTO[] = row?.jobberWorkerTypes ?? [];
    return assignedWorkerTypes.filter((workerType: JobberWorkerTypeAgencyPrivateViewDTO): boolean =>
        isValidString(workerType?.workerTypeName)
    );
};

const getWorkforceListRowWorkerTypeNames = (row: JobberFullProfileDetails): string => {
    const workerTypeNames: string[] = getWorkforceListRowWorkerTypes(row).map(
        (workerType: JobberWorkerTypeAgencyPrivateViewDTO): string => workerType.workerTypeName
    );
    const sortedWorkerTypeNames: string[] = [...workerTypeNames].sort(
        (leftWorkerTypeName: string, rightWorkerTypeName: string): number =>
            leftWorkerTypeName.localeCompare(rightWorkerTypeName, undefined, { sensitivity: 'base' })
    );
    return sortedWorkerTypeNames.join(', ');
};

const compareWorkforceListSortValues = (leftValue: string, rightValue: string): number => {
    const leftNormalized: string = leftValue ?? '';
    const rightNormalized: string = rightValue ?? '';
    return leftNormalized.localeCompare(rightNormalized, undefined, { sensitivity: 'base' });
};

const renderWorkforceListWorkerTypePills = (row: JobberFullProfileDetails): React.ReactElement => {
    const assignedWorkerTypes: JobberWorkerTypeAgencyPrivateViewDTO[] = getWorkforceListRowWorkerTypes(row);
    if (assignedWorkerTypes.length === 0) {
        return <span className="invoice-cell-text">—</span>;
    }
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '4px 0', maxHeight: '52px', overflow: 'hidden' }}>
            {assignedWorkerTypes.map((workerType: JobberWorkerTypeAgencyPrivateViewDTO, workerTypeIndex: number) => (
                <Chip
                    key={workerType.workerTypeUniqueIdentifier || `${workerType.workerTypeName}-${workerTypeIndex}`}
                    label={workerType.workerTypeName}
                    size="small"
                    sx={{
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: 600,
                        fontSize: '12px',
                        height: '24px',
                        backgroundColor: '#e8f0fb',
                        color: '#2c68bd',
                    }}
                />
            ))}
        </div>
    );
};

const ListViewV2 = ({ isMobile, jobberData, availableWorkerTypes, setJobberData, agencyData, selectedJobberEmails, setSelectedJobberEmails, setIsViewWorkerTypesModalOpen, setIsManageWorkerFileTypesModalOpen, setIsViewTemplatesModalOpen, setIsViewShiftConfigModalOpen, setIsBulkStatusModalOpen }: { isMobile: boolean; jobberData: JobberFullProfileDetails[]; availableWorkerTypes: JobberWorkerTypeAgencyPrivateViewDTO[]; setJobberData: (data: JobberFullProfileDetails[]) => void; agencyData?: AgencyObjClient | null, selectedJobberEmails: string[], setSelectedJobberEmails: React.Dispatch<React.SetStateAction<string[]>>, setIsViewWorkerTypesModalOpen: (open: boolean) => void, setIsManageWorkerFileTypesModalOpen: (open: boolean) => void, setIsViewTemplatesModalOpen: (open: boolean) => void, setIsViewShiftConfigModalOpen: (open: boolean) => void, setIsBulkStatusModalOpen: (open: boolean) => void }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState<string[]>([...DEFAULT_WORKFORCE_STATUS_FILTER]);
    const [workerTypeFilter, setWorkerTypeFilter] = useState<string[]>([]);
    const [attributeMatchingEmails, setAttributeMatchingEmails] = useState<readonly string[] | null>(null);
    const [isResendingEmail, setIsResendingEmail] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    
    const handleJobberUpdated = (updatedJobber: JobberFullProfileDetails) => {
        const updatedJobbers = jobberData.map(j => 
            j.jobberDetails.userDetails.userEmail.value === updatedJobber.jobberDetails.userDetails.userEmail.value 
                ? updatedJobber 
                : j
        );
        setJobberData(updatedJobbers);
    };

    const handleContractorDetailsCreated = async (jobberEmail: string): Promise<void> => {
        const data = await GetAllJobberAvailbilities();
        if (data) {
            const updated = data.find((j) => j.jobberDetails.userDetails.userEmail.value === jobberEmail);
            if (updated) {
                handleJobberUpdated(updated);
            }
        }
    };

    const handleResendRegistrationEmail = async (jobber: JobberFullProfileDetails) => {
        setIsResendingEmail(true);
        try {
            const request: ResendJobberRegistrationEmailRequestDTO = {
                jobberEmail: jobber.jobberDetails.userDetails.userEmail
            };
            const response = await ResendJobberRegistrationEmailAPICall(request);
            if (response) {
                enqueueSnackbar('Registration email resent successfully!', { variant: 'success' });
            } else {
                enqueueSnackbar('Failed to resend registration email. Please try again.', { variant: 'error' });
            }
        } catch (error) {
            console.error('Error resending registration email:', error);
            enqueueSnackbar('An error occurred while resending the registration email.', { variant: 'error' });
        } finally {
            setIsResendingEmail(false);
        }
    };

    const columns: GridColDef<JobberFullProfileDetails>[] = [
        {
            field: 'icon',
            headerName: '',
            width: 60,
            align: 'center',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderHeader: () => <div className="billing-header"></div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => (
                <div className="list-cell-icon-holder">
                    <img className="list-cell-icon" src={params.row.jobberDetails.profilePicUrl} />
                </div>
            ),
        },
        {
            field: 'firstName',
            headerName: 'First Name',
            minWidth: 140,
            flex: 0.7,
            sortable: true,
            valueGetter: (_value, row): string => getWorkforceListRowFirstName(row),
            sortComparator: compareWorkforceListSortValues,
            renderHeader: () => <div className="billing-header">First Name</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => (
                <span className="invoice-cell-text">{getWorkforceListRowFirstName(params.row)}</span>
            ),
        },
        {
            field: 'lastName',
            headerName: 'Last Name',
            minWidth: 140,
            flex: 0.7,
            sortable: true,
            valueGetter: (_value, row): string => getWorkforceListRowLastName(row),
            sortComparator: compareWorkforceListSortValues,
            renderHeader: () => <div className="billing-header">Last Name</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => (
                <span className="invoice-cell-text">{getWorkforceListRowLastName(params.row)}</span>
            ),
        },

        {
            field: 'status',
            headerName: 'Status',
            minWidth: 170,
            flex: 0.9,
            sortable: true,
            valueGetter: (_value, row): string => getWorkforceListRowStatus(row),
            sortComparator: compareWorkforceListSortValues,
            renderHeader: () => <div className="billing-header">Status</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => (
                <span className="invoice-cell-text">
                    {getWorkforceListRowStatus(params.row)}
                </span>
            ),
        },
        {
            field: 'email',
            headerName: 'Email',
            minWidth: 200,
            flex: 1.1,
            sortable: true,
            valueGetter: (_value, row): string => getWorkforceListRowEmail(row),
            sortComparator: compareWorkforceListSortValues,
            renderHeader: () => <div className="billing-header">Email</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => (
                <Tooltip title="Click to Copy" placement="top" PopperProps={{modifiers: [{name: 'offset',options: {offset: [0, 10],},},],sx: {'& .MuiTooltip-tooltip': {fontFamily: "'DM Sans', sans-serif",fontWeight:"700"},}}}>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            copyToClipboard(getWorkforceListRowEmail(params.row));
                        }}
                        style={{ cursor: 'pointer' }}
                        className="invoice-cell-text"
                    >
                        {getWorkforceListRowEmail(params.row)}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: 'phone',
            headerName: 'Phone',
            minWidth: 150,
            flex: 0.8,
            sortable: true,
            valueGetter: (_value, row): string => getFriendlyPhoneDisplayValue(getWorkforceListRowPhone(row)),
            sortComparator: compareWorkforceListSortValues,
            renderHeader: () => <div className="billing-header">Phone</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => (
                <Tooltip title="Click to Copy" placement="top" PopperProps={{modifiers: [{name: 'offset',options: {offset: [0, 10],},},],sx: {'& .MuiTooltip-tooltip': {fontFamily: "'DM Sans', sans-serif",fontWeight:"700"},}}}>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            copyToClipboard(getWorkforceListRowPhone(params.row));
                        }}
                        style={{ cursor: 'pointer' }}
                        className="invoice-cell-text"
                    >
                        {getFriendlyPhoneDisplayValue(getWorkforceListRowPhone(params.row))}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: 'employmentType',
            headerName: 'Employment Type',
            minWidth: 170,
            flex: 0.9,
            sortable: true,
            valueGetter: (_value, row): string => getFriendlyFieldDisplayValue(getWorkforceListRowEmploymentType(row)),
            sortComparator: compareWorkforceListSortValues,
            renderHeader: () => <div className="billing-header">Employment Type</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => (
                <span className="invoice-cell-text">
                    {getFriendlyFieldDisplayValue(getWorkforceListRowEmploymentType(params.row))}
                </span>
            ),
        },
        {
            field: 'workerTypes',
            headerName: 'Worker Types',
            minWidth: 220,
            flex: 1.4,
            sortable: true,
            valueGetter: (_value, row): string => getWorkforceListRowWorkerTypeNames(row),
            sortComparator: compareWorkforceListSortValues,
            renderHeader: () => <div className="billing-header">Worker Types</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) =>
                renderWorkforceListWorkerTypePills(params.row),
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderHeader: () => <div className="billing-header">Actions</div>,
            renderCell: (params: GridRenderCellParams<JobberFullProfileDetails>) => {
                const status = params.row.jobberDetails.jobberStatus || params.row.jobberStatus;
                if (status === JobberStatus.REGISTERED_BY_ORG_AGENCY_NEEDS_TO_ON_BOARD) {
                    return (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleResendRegistrationEmail(params.row);
                            }}
                            disabled={isResendingEmail}
                            sx={{
                                textTransform: 'none',
                                backgroundColor: '#2c68bd',
                                '&:hover': {
                                    backgroundColor: '#1e4d8c',
                                },
                                fontSize: '11px',
                                fontWeight: 600,
                                borderRadius: '6px',
                                height: '28px'
                            }}
                        >
                            {isResendingEmail ? <CircularProgress size={14} color="inherit" /> : 'Re-send Invite'}
                        </Button>
                    );
                }
                return null;
            },
        }
        
        

    ];

    const rows: JobberFullProfileDetails[] = useMemo(() => jobberData.map((jobber,index) => ({
        id: jobber.jobberDetails.userDetails.userEmail.value,
        jobberDetails: {
            userDetails: jobber.jobberDetails.userDetails,
            userType: jobber.jobberDetails.userType,
            jobberStatus: jobber.jobberDetails.jobberStatus || jobber.jobberStatus,
            profilePicUrl: jobber.jobberDetails.profilePicUrl || defaultPic,
            corpJobberDetails: jobber.jobberDetails.corpJobberDetails,
        },
        jobberAvailability: {
            cities: jobber.jobberAvailability?.cities || [],
            dayIntervals: jobber.jobberAvailability?.dayIntervals || [],
            dayOfTheWeek: jobber.jobberAvailability?.dayOfTheWeek || [],
        },
        jobberWorkerTypes: jobber.jobberWorkerTypes || [],
        jobberEmploymentDeductionsConfig: jobber.jobberEmploymentDeductionsConfig || [],
        orgLocationConfigs: jobber.orgLocationConfigs || []
    })), [jobberData]);
    
    const visibleRows: JobberFullProfileDetails[] = useMemo(() => {
        let filteredWorkforceRows: JobberFullProfileDetails[] = rows;

        if (statusFilter.length > 0) {
            filteredWorkforceRows = filteredWorkforceRows.filter((row: JobberFullProfileDetails) =>
                statusFilter.includes(row.jobberDetails.jobberStatus || row.jobberStatus)
            );
        }

        if (workerTypeFilter.length > 0) {
            filteredWorkforceRows = filteredWorkforceRows.filter((row: JobberFullProfileDetails) => {
                const jobberTypes: JobberWorkerTypeAgencyPrivateViewDTO[] = row.jobberWorkerTypes || [];
                return jobberTypes.some((workerType: JobberWorkerTypeAgencyPrivateViewDTO) =>
                    workerTypeFilter.includes(workerType.workerTypeName)
                );
            });
        }

        if (attributeMatchingEmails !== null) {
            filteredWorkforceRows = filteredWorkforceRows.filter((row: JobberFullProfileDetails) =>
                attributeMatchingEmails.includes(row.jobberDetails.userDetails.userEmail.value)
            );
        }

        if (searchQuery) {
            const fuse = new Fuse(filteredWorkforceRows, {
                keys: [
                    'jobberDetails.userDetails.firstName',
                    'jobberDetails.userDetails.lastName',
                    'jobberDetails.userDetails.userEmail.value',
                    'jobberDetails.userDetails.userPhoneNumber.value',
                    'jobberAvailability.cities',
                ],
                threshold: 0.3,
            });
            return fuse.search(searchQuery).map((fuseResult): JobberFullProfileDetails => fuseResult.item);
        }
        return filteredWorkforceRows;
    }, [rows, searchQuery, statusFilter, workerTypeFilter, attributeMatchingEmails]);

    const handleRowClick: GridEventListener<'rowClick'> = (params, event) => {
        const jobberEmail: string = params.row.jobberDetails.userDetails.userEmail.value;
        const jobberDetailsUrl: string = buildAgencyJobberDetailsUrl(jobberEmail);
        if (event?.metaKey || event?.ctrlKey) {
            window.open(jobberDetailsUrl, '_blank', 'noopener,noreferrer');
            return;
        }
        history.push(jobberDetailsUrl);
    };
    
    return (
        <>
            <div className={isMobile ? 'workforce-search-container-mobile' : 'workforce-top-actions-container'} style={isMobile ? {} : { display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'flex-start' }}>
            {!isMobile && (
                <>
                    <WorkforceHeaderActionButtons
                        isMobile={false}
                        onInviteNewWorker={(): void => {
                            history.push('/agency/add-workers');
                        }}
                        onManageWorkerTypes={(): void => {
                            setIsViewWorkerTypesModalOpen(true);
                        }}
                        onManageWorkerFileTypes={(): void => {
                            setIsManageWorkerFileTypesModalOpen(true);
                        }}
                        onManageAttributes={(): void => {
                            history.push(WORKY_WEB_APP_PATHS.agencyAttributes);
                        }}
                        onWorkforceNotices={(): void => {
                            history.push(WORKY_WEB_APP_PATHS.agencyWorkforceNotices);
                        }}
                        onOnboardingTemplates={(): void => {
                            setIsViewTemplatesModalOpen(true);
                        }}
                        onViewShiftConfigs={(): void => {
                            setIsViewShiftConfigModalOpen(true);
                        }}
                    />

                    <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                        <div className='workforce-search-container' style={{boxShadow: 'none', border: '1px solid #e5e7eb', background: 'white', height: '50px', borderRadius: '15px', flex: 1}}>
                            <Search size={18} style={{ color: '#9ca3af', flexShrink: 0, marginLeft: '10px' }} />
                            <input
                                type="text"
                                placeholder="Search By Worker, Email, Phone Number, City"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="workforce-search-input"
                                style={isMobile ? { width: '100%', minWidth: 'auto', maxWidth: '100%' } : { flex: '1 1 auto', fontSize: '13.5px', color: '#374151', fontWeight: '500' }}
                            />
                        </div>
                        <FormControl size="small" sx={{ minWidth: 200, maxWidth: 300, bgcolor: 'white', borderRadius: '15px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' } }}>
                            <Select
                                multiple
                                displayEmpty
                                value={statusFilter}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setStatusFilter(typeof value === 'string' ? value.split(',') : value);
                                }}
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <span style={{ color: '#9ca3af' }}>Filter by Status</span>;
                                    }
                                    return selected.map(status => getJobberStatusMessageForReadOnly(status)).join(', ');
                                }}
                                sx={{ 
                                    borderRadius: '15px', 
                                    height: '50px', 
                                    fontSize: '13.5px',
                                    '& .MuiSelect-select': {
                                        paddingRight: '32px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 250,
                                            borderRadius: '12px',
                                            marginTop: '8px',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }
                                }}
                            >
                                {FILTERABLE_JOBBER_STATUSES.map((status) => (
                                    <MenuItem key={status} value={status} sx={{ fontSize: '13.5px' }}>
                                        <Checkbox 
                                            checked={statusFilter.indexOf(status) > -1} 
                                            size="small"
                                            sx={{ 
                                                color: '#d1d5db',
                                                '&.Mui-checked': {
                                                    color: '#2c68bd',
                                                },
                                                padding: '4px 8px 4px 0'
                                            }}
                                        />
                                        <ListItemText 
                                            primary={getJobberStatusMessageForReadOnly(status)} 
                                            primaryTypographyProps={{ style: { fontSize: '13.5px', fontWeight: 500 } }} 
                                        />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl size="small" sx={{ minWidth: 200, maxWidth: 300, bgcolor: 'white', borderRadius: '15px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #e5e7eb' } }}>
                            <Select
                                multiple
                                displayEmpty
                                value={workerTypeFilter}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setWorkerTypeFilter(typeof value === 'string' ? value.split(',') : value);
                                }}
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <span style={{ color: '#9ca3af' }}>Filter by Worker Type</span>;
                                    }
                                    return selected.join(', ');
                                }}
                                sx={{ 
                                    borderRadius: '15px', 
                                    height: '50px', 
                                    fontSize: '13.5px',
                                    '& .MuiSelect-select': {
                                        paddingRight: '32px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 250,
                                            borderRadius: '12px',
                                            marginTop: '8px',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }
                                }}
                            >
                                {availableWorkerTypes.length === 0 ? (
                                    <MenuItem disabled value="">
                                        <span style={{ color: '#9ca3af' }}>No worker types available</span>
                                    </MenuItem>
                                ) : (
                                    availableWorkerTypes.map((type) => (
                                        <MenuItem key={type.workerTypeUniqueIdentifier} value={type.workerTypeName} sx={{ fontSize: '13.5px' }}>
                                            <Checkbox 
                                                checked={workerTypeFilter.indexOf(type.workerTypeName) > -1} 
                                                size="small"
                                                sx={{ 
                                                    color: '#d1d5db',
                                                    '&.Mui-checked': {
                                                        color: '#2c68bd',
                                                    },
                                                    padding: '4px 8px 4px 0'
                                                }}
                                            />
                                            <ListItemText 
                                                primary={type.workerTypeName} 
                                                primaryTypographyProps={{ style: { fontSize: '13.5px', fontWeight: 500 } }} 
                                            />
                                        </MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                        <WorkforceAttributeSearchFilter
                            isMobile={false}
                            onMatchingWorkerEmailsChange={setAttributeMatchingEmails}
                        />
                        <BulkActionMenu 
                            selectedEmails={selectedJobberEmails} 
                            onChangeStatus={() => setIsBulkStatusModalOpen(true)} 
                        />
                    </div>
                </>
                )}
                {isMobile && (
                    <div className='mobile-search-button-holder'>
                        <div className='mobile-search-holder'>
                        <Search size={20} style={{ color: '#7d7d7d', flexShrink: 0 }} />
                            <input
                                type="text"
                                placeholder="Search By Worker, Email, Phone Number, City"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="workforce-search-input"
                                style={isMobile ? { width: '100%', minWidth: 'auto', maxWidth: '100%' } : { flex: '1 1 auto' }}
                            />
                        </div>
                        <div style={{marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap'}}>
                            <FormControl size="small" sx={{ flex: 1, minWidth: '140px', bgcolor: 'white', borderRadius: '8px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' } }}>
                                <Select
                                    multiple
                                    displayEmpty
                                    value={statusFilter}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        setStatusFilter(typeof value === 'string' ? value.split(',') : value);
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <span style={{ color: '#9ca3af' }}>Status</span>;
                                        }
                                        return selected.map(status => getJobberStatusMessageForReadOnly(status)).join(', ');
                                    }}
                                    sx={{ 
                                        borderRadius: '8px', 
                                        height: '42px', 
                                        fontSize: '14px', 
                                        '& .MuiSelect-select': {
                                            paddingRight: '32px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                                width: 250,
                                                borderRadius: '12px',
                                                marginTop: '8px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                            },
                                        },
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }
                                    }}
                                >
                                    {FILTERABLE_JOBBER_STATUSES.map((status) => (
                                        <MenuItem key={status} value={status} sx={{ fontSize: '13.5px' }}>
                                            <Checkbox 
                                                checked={statusFilter.indexOf(status) > -1} 
                                                size="small"
                                                sx={{ 
                                                    color: '#d1d5db',
                                                    '&.Mui-checked': {
                                                        color: '#2c68bd',
                                                    },
                                                    padding: '4px 8px 4px 0'
                                                }}
                                            />
                                            <ListItemText 
                                                primary={getJobberStatusMessageForReadOnly(status)} 
                                                primaryTypographyProps={{ style: { fontSize: '13.5px', fontWeight: 500 } }} 
                                            />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small" sx={{ flex: 1, minWidth: '140px', bgcolor: 'white', borderRadius: '8px', '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' }, '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #d1d5db' } }}>
                                <Select
                                    multiple
                                    displayEmpty
                                    value={workerTypeFilter}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        setWorkerTypeFilter(typeof value === 'string' ? value.split(',') : value);
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <span style={{ color: '#9ca3af' }}>Worker Types</span>;
                                        }
                                        return selected.join(', ');
                                    }}
                                    sx={{ 
                                        borderRadius: '8px', 
                                        height: '42px', 
                                        fontSize: '14px', 
                                        '& .MuiSelect-select': { 
                                            padding: '8px 32px 8px 14px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        } 
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                                width: 250,
                                                borderRadius: '12px',
                                                marginTop: '8px'
                                            },
                                        },
                                    }}
                                >
                                    {availableWorkerTypes.length === 0 ? (
                                        <MenuItem disabled value="">
                                            <span style={{ color: '#9ca3af' }}>No worker types available</span>
                                        </MenuItem>
                                    ) : (
                                        availableWorkerTypes.map((type) => (
                                            <MenuItem key={type.workerTypeUniqueIdentifier} value={type.workerTypeName}>
                                                <Checkbox 
                                                    checked={workerTypeFilter.indexOf(type.workerTypeName) > -1} 
                                                    size="small"
                                                    sx={{ 
                                                        color: '#d1d5db',
                                                        '&.Mui-checked': {
                                                            color: '#2c68bd',
                                                        },
                                                        padding: '4px 8px 4px 0'
                                                    }}
                                                />
                                                <ListItemText 
                                                    primary={type.workerTypeName} 
                                                    primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 500 } }}
                                                />
                                            </MenuItem>
                                        ))
                                    )}
                                </Select>
                            </FormControl>
                            <WorkforceAttributeSearchFilter
                                isMobile={true}
                                onMatchingWorkerEmailsChange={setAttributeMatchingEmails}
                            />
                            <BulkActionMenu 
                                selectedEmails={selectedJobberEmails} 
                                onChangeStatus={() => setIsBulkStatusModalOpen(true)} 
                            />
                        </div>
                        <WorkforceHeaderActionButtons
                            isMobile={true}
                            onInviteNewWorker={(): void => {
                                history.push('/agency/add-workers');
                            }}
                            onManageWorkerTypes={(): void => {
                                setIsViewWorkerTypesModalOpen(true);
                            }}
                            onManageWorkerFileTypes={(): void => {
                                setIsManageWorkerFileTypesModalOpen(true);
                            }}
                            onManageAttributes={(): void => {
                                history.push(WORKY_WEB_APP_PATHS.agencyAttributes);
                            }}
                            onWorkforceNotices={(): void => {
                                history.push(WORKY_WEB_APP_PATHS.agencyWorkforceNotices);
                            }}
                            onOnboardingTemplates={(): void => {
                                setIsViewTemplatesModalOpen(true);
                            }}
                            onViewShiftConfigs={(): void => {
                                setIsViewShiftConfigModalOpen(true);
                            }}
                        />
                    </div>
                )}
            </div>
            <div className={isMobile ? 'workforce-container-list-mobile' : 'workforce-container-list'}>
                <DataGrid
                    sx={{
                        width: '100%',
                        borderRadius: '10px',
                        border: '1px solid #ebebeb',
                        '& .MuiDataGrid-cell': {
                            py: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            overflow: 'hidden',
                        },
                        '& .MuiDataGrid-row': {
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: '#f5f5f5',
                            },
                        },
                    }}
                    checkboxSelection
                    disableRowSelectionOnClick
                    getRowId={(row: JobberFullProfileDetails): string =>
                        row.jobberDetails.userDetails.userEmail.value
                    }
                    rowSelectionModel={selectedJobberEmails}
                    onRowSelectionModelChange={(newSelection) => {
                            setSelectedJobberEmails(newSelection as string[]);
                    }}
                    rows={visibleRows}
                    columns={columns}
                    sortingOrder={['asc', 'desc']}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 50 },
                        },
                    }}
                    pageSizeOptions={[10, 15, 25, 50]}
                    onRowClick={handleRowClick}
                />
            </div>
        </>
    );
};

const MyAgencyWorkforce = () => {
    const isMobile = useIsMobile();
    const history = useHistory();
    const [jobberData, setJobberData] = useState<JobberFullProfileDetails[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [gridViewActive, setGridViewActive] = useState<boolean>(isMobile);

    useEffect(() => {
        setGridViewActive(isMobile);
    }, [isMobile]);
    const [isAddWorkerModalOpen, setIsAddWorkerModalOpen] = useState(false);
    const [isAddWorkerTypeModalOpen, setIsAddWorkerTypeModalOpen] = useState(false);
    const [isViewWorkerTypesModalOpen, setIsViewWorkerTypesModalOpen] = useState(false);
    const [isManageWorkerFileTypesModalOpen, setIsManageWorkerFileTypesModalOpen] = useState(false);
    const [isViewTemplatesModalOpen, setIsViewTemplatesModalOpen] = useState(false);
    const [isViewShiftConfigModalOpen, setIsViewShiftConfigModalOpen] = useState(false);
    const [modalAddWorkerTypeParamater, setModalAddWorkerTypeParamater] = useState<CreateJobberWorkerTypeReqDTO>({
        workerTypeName: '',
        defaultJobberPayRate: 0,
        orgHourlyRateMarkupType: OrgHourlyRateMarkupType.DEFAULT_CONFIGURED_HOURLY_RATE_MARKUP_TYPE,
        defaultOrgBillingPayRate: 0
    });
    const [availableWorkerTypes, setAvailableWorkerTypes] = useState<JobberWorkerTypeAgencyPrivateViewDTO[]>([]);
    const [agencyData, setAgencyData] = useState<AgencyObjClient | null>(null);
    const [selectedJobberEmails, setSelectedJobberEmails] = useState<string[]>([]);
    const [isBulkStatusModalOpen, setIsBulkStatusModalOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleToggleSelection = (email: string) => {
        setSelectedJobberEmails(prev => {
            if (prev.includes(email)) {
                return prev.filter(e => e !== email);
            } else {
                return [...prev, email];
            }
        });
    };

    const handleBulkStatusChanged = () => {
        setSelectedJobberEmails([]);
        window.location.reload();
    };
    const showSuccessMessage = (message: string) => {
        enqueueSnackbar(message, { variant: 'success' });
      };

      const showErrorMessage = (message: string) => {
        enqueueSnackbar(message, { variant: 'error' });
      };
    
    const fetchJobberData = async () => {
        try {
            setIsLoading(true);
            const data = await GetAllJobberAvailbilities();
            if (data && Array.isArray(data)) { // Ensure data is an array
                setJobberData(data);
            }
        } catch (error) {
            console.error('Error fetching jobber data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAgencyData = async () => {
        try {
            const agency = await GetAgencyWTokenOnly({});
            if (agency?.jobberWorkerTypes) {
                // Use the full JobberWorkerTypeAgencyPrivateViewDTO[] to keep defaultJobberPayRate
                setAvailableWorkerTypes(agency.jobberWorkerTypes);
                setAgencyData(agency);
            }
        } catch (error) {
            console.error('Error fetching agency data:', error);
        }
    };
	
    useEffect(() => {        
        fetchJobberData();
        fetchAgencyData();
    }, []);

    return(
        <>
            <div className={isMobile?'org-app-v2-mobile':'org-app-v3'}>
                <StyleLinks/>    
                <WorkyNavigation/>
                <div className={isMobile?'worky-leads-mobile-container':'worky-leads-desktop-container'}>
                <PageHeader isMobile={isMobile} gridViewActive={gridViewActive} setGridViewActive={setGridViewActive}/>

                {isLoading ? (
                    <div style={{paddingTop:"100px"}}>
                        <CircularProgress size={60} thickness={5} style={{ color: '#2c68bd' }} />
                    </div>
                ) : jobberData && jobberData.length > 0 ? (
                    gridViewActive ? 
                        (<GridViewV2 
                            isMobile={isMobile} 
                            jobberData={jobberData} 
                            availableWorkerTypes={availableWorkerTypes} 
                            setJobberData={setJobberData} 
                            agencyData={agencyData}
                            selectedJobberEmails={selectedJobberEmails}
                            handleToggleSelection={handleToggleSelection}
                            setIsViewWorkerTypesModalOpen={setIsViewWorkerTypesModalOpen}
                            setIsManageWorkerFileTypesModalOpen={setIsManageWorkerFileTypesModalOpen}
                            setIsViewTemplatesModalOpen={setIsViewTemplatesModalOpen}
                            setIsViewShiftConfigModalOpen={setIsViewShiftConfigModalOpen}
                            setIsBulkStatusModalOpen={setIsBulkStatusModalOpen}
                        />)
                        :
                        (<ListViewV2 
                            isMobile={isMobile} 
                            jobberData={jobberData} 
                            availableWorkerTypes={availableWorkerTypes} 
                            setJobberData={setJobberData} 
                            agencyData={agencyData}
                            selectedJobberEmails={selectedJobberEmails}
                            setSelectedJobberEmails={setSelectedJobberEmails}
                            setIsViewWorkerTypesModalOpen={setIsViewWorkerTypesModalOpen}
                            setIsManageWorkerFileTypesModalOpen={setIsManageWorkerFileTypesModalOpen}
                            setIsViewTemplatesModalOpen={setIsViewTemplatesModalOpen}
                            setIsViewShiftConfigModalOpen={setIsViewShiftConfigModalOpen}
                            setIsBulkStatusModalOpen={setIsBulkStatusModalOpen}
                        />)
                ) : (
                    <div style={{paddingTop:"100px", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
                        <Typography variant="h6" style={{ color: '#666', textAlign: 'center', padding: '0 20px' }}>
                            You have no workers currently, Invite your workers to the platform
                        </Typography>
                        <div style={{ display: 'flex', gap: '10px', width: isMobile ? '100%' : 'auto', justifyContent: 'center', padding: isMobile ? '0 20px' : '0', flexWrap: 'wrap' }}>
                            <WorkforceHeaderActionButtons
                                isMobile={isMobile}
                                onInviteNewWorker={(): void => {
                                    history.push('/agency/add-workers');
                                }}
                                onManageWorkerTypes={(): void => {
                                    setIsViewWorkerTypesModalOpen(true);
                                }}
                                onManageWorkerFileTypes={(): void => {
                                    setIsManageWorkerFileTypesModalOpen(true);
                                }}
                                onManageAttributes={(): void => {
                                    history.push(WORKY_WEB_APP_PATHS.agencyAttributes);
                                }}
                                onWorkforceNotices={(): void => {
                                    history.push(WORKY_WEB_APP_PATHS.agencyWorkforceNotices);
                                }}
                                onOnboardingTemplates={(): void => {
                                    setIsViewTemplatesModalOpen(true);
                                }}
                                onViewShiftConfigs={(): void => {
                                    setIsViewShiftConfigModalOpen(true);
                                }}
                            />
                        </div>
                    </div>
                )}

                <WorkyContactButton/>
                </div>
            </div>
            <AddNewWorkerModal 
                isOpen={isAddWorkerModalOpen} 
                onClose={() => setIsAddWorkerModalOpen(false)}
                availableWorkerTypes={availableWorkerTypes}
                agencyData={agencyData}
            />
            <WorkyQuickActionsAddWorkerTypeModal 
                modalOpen={isAddWorkerTypeModalOpen} 
                handleClose={() => setIsAddWorkerTypeModalOpen(false)} 
                isMobile={isMobile} 
                modalParamater={modalAddWorkerTypeParamater} 
                setModalParamater={setModalAddWorkerTypeParamater} 
            />
            <ViewWorkerTypesModal
                isOpen={isViewWorkerTypesModalOpen}
                onClose={() => setIsViewWorkerTypesModalOpen(false)}
                isMobile={isMobile}
                agencyData={agencyData}
                onCreateWorkerType={() => setIsAddWorkerTypeModalOpen(true)}
            />
            <ManageWorkerFileTypesModal
                isOpen={isManageWorkerFileTypesModalOpen}
                onClose={() => setIsManageWorkerFileTypesModalOpen(false)}
                isMobile={isMobile}
            />
            <ViewOnboardingTemplatesModal
                isOpen={isViewTemplatesModalOpen}
                onClose={() => setIsViewTemplatesModalOpen(false)}
                isMobile={isMobile}
            />
            <ViewShiftConfigModal 
                open={isViewShiftConfigModalOpen} 
                onClose={() => setIsViewShiftConfigModalOpen(false)} 
                shiftAssignmentConfigRules={agencyData?.shiftAssignmentConfigRules}
            />
            <ChangeJobberStatusModal
                isOpen={isBulkStatusModalOpen}
                onClose={() => setIsBulkStatusModalOpen(false)}
                jobberEmails={selectedJobberEmails}
                onStatusChanged={handleBulkStatusChanged}
            />
        </>
    )
}


export { MyAgencyWorkforce, WorkforceTagBuilder, copyToClipboard, ChangeJobberStatusModal, CrudMyWorkerTypes}